var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthLayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 552,
    height: 650,
    viewBox: "0 0 552 650",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_640)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M501.502 321.793C499.49 321.793 497.477 321.427 495.464 320.694C494.915 320.51 494.733 319.961 494.916 319.411C495.098 318.861 495.647 318.678 496.196 318.861C498.026 319.411 499.856 319.777 501.685 319.777C502.234 319.777 502.6 320.327 502.6 320.694C502.6 321.243 502.051 321.793 501.502 321.793ZM507.357 320.694C506.991 320.694 506.625 320.51 506.442 320.144C506.259 319.594 506.442 319.044 506.991 318.861C508.638 318.128 510.101 317.028 511.199 315.562C511.565 315.196 512.114 315.013 512.663 315.379C513.029 315.746 513.212 316.295 512.846 316.845C511.382 318.494 509.736 319.777 507.906 320.694C507.54 320.694 507.357 320.694 507.357 320.694ZM490.524 318.311C490.341 318.311 490.158 318.311 489.975 318.128L484.853 315.196C484.304 315.013 484.304 314.28 484.487 313.913C484.67 313.363 485.401 313.363 485.767 313.547L490.89 316.479C491.439 316.662 491.439 317.395 491.256 317.761C491.256 318.128 490.89 318.311 490.524 318.311ZM480.461 312.447C480.278 312.447 480.095 312.447 479.912 312.264L474.79 309.332C474.241 309.149 474.241 308.416 474.424 308.049C474.607 307.499 475.338 307.499 475.704 307.683L480.827 310.615C481.376 310.798 481.376 311.531 481.193 311.897C481.01 312.264 480.644 312.447 480.461 312.447ZM514.676 312.081C514.493 312.081 514.493 312.081 514.31 312.081C513.761 311.897 513.578 311.348 513.761 310.798C514.31 309.149 514.676 307.316 514.858 305.3C514.858 304.75 515.407 304.384 515.956 304.384C516.505 304.384 516.871 304.934 516.871 305.483C516.688 307.683 516.322 309.698 515.773 311.531C515.407 311.714 515.041 312.081 514.676 312.081ZM470.215 306.583C470.033 306.583 469.85 306.583 469.667 306.4L464.544 303.468C463.995 303.284 463.995 302.551 464.178 302.185C464.361 301.635 465.092 301.635 465.458 301.818L470.581 304.75C471.13 304.934 471.13 305.667 470.947 306.033C470.947 306.4 470.581 306.583 470.215 306.583ZM460.152 300.719C459.97 300.719 459.787 300.719 459.604 300.536L454.481 297.604C453.932 297.42 453.932 296.687 454.115 296.321C454.298 295.771 455.03 295.771 455.395 295.954L460.518 298.886C461.067 299.07 461.067 299.803 460.884 300.169C460.701 300.536 460.518 300.719 460.152 300.719ZM449.541 294.672C449.358 294.672 449.175 294.672 448.992 294.488L443.869 291.556C443.32 291.373 443.32 290.64 443.503 290.273C443.686 289.724 444.418 289.724 444.784 289.907L449.907 292.839C450.455 293.022 450.455 293.755 450.272 294.122C450.272 294.488 449.907 294.672 449.541 294.672ZM439.478 288.807C439.295 288.807 439.112 288.807 438.929 288.624L433.806 285.692C433.257 285.509 433.257 284.776 433.44 284.409C433.623 283.86 434.355 283.86 434.721 284.043L439.844 286.975C440.392 287.158 440.392 287.891 440.21 288.258C440.21 288.624 439.844 288.807 439.478 288.807ZM515.773 298.52C515.224 298.52 514.858 298.153 514.858 297.604V291.739C514.858 291.19 515.224 290.823 515.773 290.823C516.322 290.823 516.688 291.19 516.688 291.739V297.604C516.688 298.153 516.322 298.52 515.773 298.52ZM429.415 282.943C429.232 282.943 429.049 282.943 428.866 282.76L423.743 279.828C423.194 279.645 423.194 278.912 423.377 278.545C423.56 277.995 424.292 277.995 424.658 278.179L429.781 281.111C430.329 281.294 430.33 282.027 430.147 282.394C429.964 282.76 429.598 282.943 429.415 282.943ZM419.169 277.079C418.986 277.079 418.803 277.079 418.62 276.896L415.327 275.063C414.778 274.697 414.046 274.33 413.497 273.964C413.131 273.597 412.948 273.048 413.131 272.681C413.497 272.315 414.046 272.131 414.412 272.315C414.961 272.681 415.509 273.048 416.058 273.414L419.352 275.247C419.901 275.43 419.901 276.163 419.718 276.529C419.901 276.896 419.535 277.079 419.169 277.079ZM515.773 286.792C515.224 286.792 514.858 286.425 514.858 285.875V280.011C514.858 279.462 515.224 279.095 515.773 279.095C516.322 279.095 516.688 279.462 516.688 280.011V285.875C516.688 286.425 516.322 286.792 515.773 286.792ZM409.472 270.482C409.289 270.482 408.923 270.482 408.74 270.299C407.276 269.016 405.812 267.55 404.532 266.084C404.166 265.717 404.166 264.984 404.532 264.618C404.898 264.251 405.629 264.251 405.995 264.618C407.276 266.084 408.74 267.367 410.021 268.65C410.387 269.016 410.387 269.566 410.021 270.116C410.021 270.482 409.838 270.482 409.472 270.482ZM515.773 275.063C515.224 275.063 514.858 274.697 514.858 274.147V268.283C514.858 267.733 515.224 267.367 515.773 267.367C516.322 267.367 516.688 267.733 516.688 268.283V274.147C516.688 274.697 516.322 275.063 515.773 275.063ZM401.604 261.869C401.238 261.869 401.055 261.686 400.872 261.503C399.775 259.853 398.677 258.204 397.579 256.555C397.213 256.005 397.396 255.455 397.945 255.272C398.494 254.906 399.043 255.089 399.226 255.639C400.141 257.288 401.238 258.937 402.336 260.403C402.702 260.77 402.519 261.503 402.153 261.686C402.153 261.869 401.787 261.869 401.604 261.869ZM515.773 263.335C515.224 263.335 514.858 262.969 514.858 262.419V256.555C514.858 256.005 515.224 255.639 515.773 255.639C516.322 255.639 516.688 256.005 516.688 256.555V262.419C516.688 262.969 516.322 263.335 515.773 263.335ZM395.749 251.79C395.384 251.79 395.018 251.607 394.835 251.24C393.92 249.408 393.188 247.575 392.639 245.743C392.456 245.193 392.639 244.643 393.188 244.46C393.737 244.277 394.286 244.46 394.469 245.01C395.018 246.842 395.749 248.492 396.664 250.324C396.847 250.874 396.664 251.424 396.115 251.607C395.932 251.79 395.749 251.79 395.749 251.79ZM515.773 251.607C515.224 251.607 514.858 251.24 514.858 250.691V244.827C514.858 244.277 515.224 243.91 515.773 243.91C516.322 243.91 516.688 244.277 516.688 244.827V250.691C516.688 251.24 516.322 251.607 515.773 251.607ZM391.724 240.795C391.358 240.795 390.809 240.429 390.809 240.062C390.261 238.046 390.078 236.03 389.895 234.198C389.895 233.648 390.261 233.098 390.809 233.098C391.358 233.098 391.907 233.465 391.907 234.015C392.09 235.847 392.456 237.68 392.822 239.696C393.005 240.245 392.639 240.795 392.09 240.795C391.907 240.795 391.907 240.795 391.724 240.795ZM515.773 239.879C515.224 239.879 514.858 239.512 514.858 238.962V233.098C514.858 232.549 515.224 232.182 515.773 232.182C516.322 232.182 516.688 232.549 516.688 233.098V238.962C516.688 239.512 516.322 239.879 515.773 239.879ZM515.773 228.151C515.224 228.151 514.858 227.784 514.858 227.234V221.37C514.858 220.82 515.224 220.454 515.773 220.454C516.322 220.454 516.688 220.82 516.688 221.37V227.234C516.688 227.784 516.322 228.151 515.773 228.151ZM515.773 216.422C515.224 216.422 514.858 216.056 514.858 215.506V209.642C514.858 209.092 515.224 208.726 515.773 208.726C516.322 208.726 516.688 209.092 516.688 209.642V215.506C516.688 216.056 516.322 216.422 515.773 216.422ZM515.773 204.694C515.224 204.694 514.858 204.328 514.858 203.778V197.914C514.858 197.364 515.224 196.997 515.773 196.997C516.322 196.997 516.688 197.364 516.688 197.914V203.778C516.688 204.328 516.322 204.694 515.773 204.694ZM390.626 227.234C390.078 227.234 389.712 226.868 389.712 226.318V220.454C389.712 219.904 390.078 219.538 390.626 219.538C391.175 219.538 391.541 219.904 391.541 220.454V226.318C391.724 226.868 391.175 227.234 390.626 227.234ZM515.773 192.966C515.224 192.966 514.858 192.599 514.858 192.05V186.186C514.858 185.636 515.224 185.269 515.773 185.269C516.322 185.269 516.688 185.636 516.688 186.186V192.05C516.688 192.599 516.322 192.966 515.773 192.966ZM390.626 215.506C390.078 215.506 389.712 215.14 389.712 214.59V208.726C389.712 208.176 390.078 207.809 390.626 207.809C391.175 207.809 391.541 208.176 391.541 208.726V214.59C391.724 215.14 391.175 215.506 390.626 215.506ZM390.626 203.778C390.078 203.778 389.712 203.411 389.712 202.862V196.997C389.712 196.448 390.078 196.081 390.626 196.081C391.175 196.081 391.541 196.448 391.541 196.997V202.862C391.724 203.411 391.175 203.778 390.626 203.778ZM515.773 181.421C515.224 181.421 514.858 181.054 514.858 180.505V177.756C514.858 176.656 514.858 175.557 514.676 174.457C514.676 173.908 515.041 173.358 515.59 173.358C516.139 173.358 516.688 173.724 516.688 174.274C516.871 175.374 516.871 176.473 516.871 177.756V180.321C516.688 180.871 516.322 181.421 515.773 181.421ZM390.626 192.05C390.078 192.05 389.712 191.683 389.712 191.133V185.269C389.712 184.719 390.078 184.353 390.626 184.353C391.175 184.353 391.541 184.719 391.541 185.269V191.133C391.724 191.683 391.175 192.05 390.626 192.05ZM514.676 169.693C514.31 169.693 513.761 169.326 513.761 168.96C513.395 167.127 512.846 165.295 512.114 163.462C511.931 162.912 512.114 162.363 512.663 162.179C513.212 161.996 513.761 162.179 513.944 162.729C514.676 164.562 515.224 166.577 515.59 168.41C515.773 168.96 515.407 169.509 514.858 169.509C514.858 169.693 514.858 169.693 514.676 169.693ZM390.626 180.321C390.078 180.321 389.712 179.955 389.712 179.405V173.541C389.712 172.991 390.078 172.625 390.626 172.625C391.175 172.625 391.541 172.991 391.541 173.541V179.405C391.724 179.955 391.175 180.321 390.626 180.321ZM510.833 158.697C510.467 158.697 510.101 158.514 509.919 158.148C509.187 156.498 508.272 154.666 507.174 153.017C506.808 152.467 506.991 151.917 507.54 151.734C508.089 151.551 508.638 151.551 508.821 152.1C509.918 153.75 510.833 155.582 511.565 157.415C511.748 157.964 511.565 158.514 511.016 158.697C511.199 158.697 511.016 158.697 510.833 158.697ZM390.626 168.593C390.078 168.593 389.712 168.227 389.712 167.677V161.813C389.712 161.263 390.078 160.897 390.626 160.897C391.175 160.897 391.541 161.263 391.541 161.813V167.677C391.724 168.227 391.175 168.593 390.626 168.593ZM504.796 148.619C504.43 148.619 504.247 148.435 504.064 148.252C502.966 146.603 501.685 145.137 500.404 143.854C500.038 143.487 500.038 142.754 500.404 142.388C500.77 142.021 501.502 142.021 501.868 142.388C503.149 143.854 504.43 145.32 505.527 146.969C505.893 147.336 505.71 148.069 505.344 148.252C505.344 148.619 504.978 148.619 504.796 148.619ZM390.626 156.865C390.078 156.865 389.712 156.498 389.712 155.949V150.085C389.712 149.535 390.078 149.168 390.626 149.168C391.175 149.168 391.541 149.535 391.541 150.085V155.949C391.724 156.498 391.175 156.865 390.626 156.865ZM497.111 140.006C496.928 140.006 496.562 140.006 496.379 139.822C494.915 138.54 493.452 137.257 491.805 136.341C491.439 135.974 491.256 135.424 491.439 135.058C491.805 134.691 492.354 134.508 492.72 134.691C494.367 135.791 495.83 136.89 497.477 138.356C497.843 138.723 497.843 139.273 497.477 139.822C497.66 139.822 497.294 140.006 497.111 140.006ZM390.626 145.137C390.078 145.137 389.712 144.77 389.712 144.22V138.356C389.712 137.807 390.078 137.44 390.626 137.44C391.175 137.44 391.541 137.807 391.541 138.356V144.22C391.724 144.77 391.175 145.137 390.626 145.137ZM487.414 133.409C487.231 133.409 487.048 133.409 486.865 133.225L481.742 130.293C481.193 130.11 481.193 129.377 481.376 129.01C481.559 128.461 482.291 128.461 482.657 128.644L487.78 131.576C488.329 131.759 488.329 132.492 488.146 132.859C487.963 133.225 487.78 133.409 487.414 133.409ZM477.168 127.544C476.985 127.544 476.802 127.544 476.619 127.361L471.496 124.429C470.947 124.246 470.947 123.513 471.13 123.146C471.313 122.597 472.045 122.597 472.411 122.78L477.534 125.712C478.083 125.895 478.083 126.628 477.9 126.995C477.9 127.361 477.534 127.544 477.168 127.544ZM390.626 133.592C390.078 133.592 389.712 133.225 389.712 132.675V126.811C389.712 126.262 390.078 125.895 390.626 125.895C391.175 125.895 391.541 126.262 391.541 126.811V132.675C391.724 133.042 391.175 133.592 390.626 133.592ZM467.105 121.68C466.922 121.68 466.739 121.68 466.556 121.497L461.433 118.565C460.884 118.382 460.884 117.649 461.067 117.282C461.25 116.732 461.982 116.732 462.348 116.916L467.471 119.848C468.02 120.031 468.02 120.764 467.837 121.131C467.654 121.497 467.471 121.68 467.105 121.68ZM456.859 115.816C456.676 115.816 456.493 115.816 456.31 115.633L451.187 112.701C450.638 112.518 450.638 111.785 450.821 111.418C451.004 110.868 451.736 110.868 452.102 111.052L457.225 113.984C457.774 114.167 457.774 114.9 457.591 115.266C457.591 115.633 457.225 115.816 456.859 115.816ZM390.626 121.864C390.078 121.864 389.712 121.497 389.712 120.947V115.083C389.712 114.533 390.078 114.167 390.626 114.167C391.175 114.167 391.541 114.533 391.541 115.083V120.947C391.724 121.314 391.175 121.864 390.626 121.864ZM390.626 110.135C390.078 110.135 389.712 109.769 389.712 109.219V105.737C389.712 104.821 389.712 104.088 389.712 103.355C389.712 102.805 390.261 102.439 390.809 102.439C391.358 102.439 391.724 102.988 391.724 103.538C391.724 104.271 391.724 105.004 391.724 105.737V109.219C391.724 109.586 391.175 110.135 390.626 110.135ZM446.43 109.769C446.247 109.769 446.064 109.769 445.881 109.586L440.758 106.654C440.209 106.47 440.21 105.737 440.392 105.371C440.575 104.821 441.307 104.821 441.673 105.004L446.796 107.936C447.345 108.12 447.345 108.853 447.162 109.219C447.162 109.586 446.796 109.769 446.43 109.769ZM436.367 103.905C436.184 103.905 436.001 103.905 435.818 103.721L430.695 100.789C430.147 100.606 430.147 99.8731 430.329 99.5066C430.512 99.1401 431.244 98.9569 431.61 99.1401L436.733 102.072C437.282 102.255 437.282 102.988 437.099 103.355C436.916 103.721 436.733 103.905 436.367 103.905ZM391.907 98.4071C391.724 98.4071 391.724 98.4071 391.541 98.4071C390.992 98.2238 390.809 97.6741 390.992 97.1243C391.724 95.1085 392.639 93.276 393.92 91.6267C394.286 91.2602 394.835 91.077 395.384 91.4435C395.749 91.81 395.932 92.3597 395.566 92.9095C394.469 94.1923 393.554 95.8416 393.005 97.6741C392.639 98.2238 392.273 98.4071 391.907 98.4071ZM426.121 98.0406C425.938 98.0406 425.755 98.0406 425.572 97.8573L420.449 94.9253C419.901 94.742 419.901 94.009 420.084 93.6425C420.267 93.0927 420.998 93.0928 421.364 93.276L426.487 96.2081C427.036 96.3913 427.036 97.1243 426.853 97.4908C426.853 97.8573 426.487 98.0406 426.121 98.0406ZM416.058 92.1765C415.875 92.1765 415.692 92.1765 415.692 91.9932H415.509C413.863 91.077 412.033 90.1607 410.387 89.6109C409.838 89.4277 409.655 88.8779 409.838 88.3282C410.021 87.7784 410.569 87.5952 411.118 87.7784C412.948 88.3282 414.778 89.2444 416.607 90.3439C417.156 90.5272 417.339 91.2602 416.973 91.6267C416.607 91.9932 416.241 92.1765 416.058 92.1765ZM399.226 89.7942C398.86 89.7942 398.494 89.6109 398.311 89.2444C398.128 88.6947 398.311 88.1449 398.86 87.9617C400.689 87.2286 402.519 86.8621 404.715 86.8621H405.081C405.629 86.8621 405.995 87.4119 405.995 87.7784C405.995 88.3282 405.629 88.6947 405.081 88.6947H404.898C403.068 88.6947 401.421 89.0612 399.775 89.7942C399.409 89.7942 399.409 89.7942 399.226 89.7942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.309 256.644C543.865 250.463 543.74 230.579 533.03 212.23C522.32 193.882 505.081 184.018 494.526 190.199C483.971 196.379 484.096 216.264 494.806 234.612C505.515 252.961 522.754 262.825 533.309 256.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M526.202 259.487C522.177 259.487 517.969 258.204 513.395 255.639C498.026 246.842 485.584 225.218 485.584 207.626C485.584 195.348 491.805 187.285 501.685 187.285C505.71 187.285 509.918 188.568 514.492 191.133C529.861 199.93 542.303 221.553 542.303 239.146C542.303 251.607 536.082 259.487 526.202 259.487ZM501.685 189.301C493.086 189.301 487.597 196.264 487.597 207.626C487.597 224.669 499.672 245.376 514.492 253.989C518.701 256.372 522.543 257.654 526.202 257.654C534.801 257.654 540.29 250.691 540.29 239.329C540.29 222.286 528.215 201.579 513.395 192.966C509.369 190.584 505.344 189.301 501.685 189.301Z",
    fill: "url(#paint0_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.019 216.422L517.237 224.485V224.669L531.142 230.533V237.68L517.237 227.784V227.967L526.019 245.743L520.164 246.109L514.675 228.151L514.493 227.967L508.455 239.329L503.149 232.549L511.931 224.669V224.485L498.392 218.621V211.474L511.931 221.37V221.187L503.332 203.228L509.004 202.862L514.675 220.82L514.858 221.004L520.53 209.459L526.019 216.422Z",
    fill: "url(#paint1_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M204.004 371.821C201.991 371.821 199.979 371.455 197.966 370.722C197.417 370.538 197.234 369.989 197.417 369.439C197.6 368.889 198.149 368.706 198.698 368.889C200.528 369.439 202.357 369.805 204.187 369.805C204.736 369.805 205.102 370.355 205.102 370.722C205.102 371.455 204.553 371.821 204.004 371.821ZM209.676 370.905C209.31 370.905 208.944 370.722 208.761 370.355C208.578 369.805 208.761 369.256 209.31 369.072C210.957 368.339 212.42 367.24 213.518 365.774C213.884 365.407 214.433 365.224 214.982 365.591C215.348 365.957 215.531 366.507 215.165 367.057C213.701 368.706 212.054 369.989 210.225 370.905C210.042 370.722 209.859 370.905 209.676 370.905ZM193.026 368.339C192.843 368.339 192.66 368.339 192.477 368.156L187.354 365.224C186.805 365.041 186.805 364.308 186.988 363.941C187.171 363.392 187.903 363.392 188.269 363.575L193.392 366.507C193.941 366.69 193.941 367.423 193.758 367.79C193.758 368.156 193.392 368.339 193.026 368.339ZM182.78 362.475C182.597 362.475 182.414 362.475 182.231 362.292L177.108 359.36C176.559 359.177 176.559 358.444 176.742 358.077C176.925 357.527 177.657 357.527 178.023 357.711L183.146 360.643C183.695 360.826 183.695 361.559 183.512 361.926C183.512 362.292 183.146 362.475 182.78 362.475ZM217.177 362.109C216.994 362.109 216.994 362.109 216.811 362.109C216.262 361.926 216.08 361.376 216.262 360.826C216.811 359.177 217.177 357.344 217.36 355.328C217.36 354.779 217.909 354.412 218.458 354.412C219.007 354.412 219.373 354.962 219.373 355.512C219.19 357.711 218.824 359.727 218.275 361.559C217.909 361.926 217.543 362.109 217.177 362.109ZM172.717 356.794C172.534 356.794 172.351 356.794 172.168 356.611L167.045 353.679C166.497 353.496 166.496 352.763 166.679 352.396C166.862 351.847 167.594 351.847 167.96 352.03L173.083 354.962C173.632 355.145 173.632 355.878 173.449 356.245C173.449 356.611 173.083 356.794 172.717 356.794ZM162.654 350.93C162.471 350.93 162.288 350.93 162.105 350.747L156.982 347.815C156.434 347.632 156.434 346.899 156.616 346.532C156.799 345.983 157.531 345.982 157.897 346.166L163.02 349.098C163.569 349.281 163.569 350.014 163.386 350.381C163.203 350.747 162.837 350.93 162.654 350.93ZM152.408 345.066C152.225 345.066 152.042 345.066 151.859 344.883L146.736 341.951C146.188 341.768 146.188 341.035 146.371 340.668C146.554 340.118 147.285 340.118 147.651 340.302L152.774 343.234C153.323 343.417 153.323 344.15 153.14 344.516C153.14 344.883 152.774 345.066 152.408 345.066ZM142.345 339.202C142.162 339.202 141.979 339.202 141.796 339.019L136.674 336.087C136.125 335.904 136.125 335.171 136.308 334.804C136.491 334.254 137.222 334.254 137.588 334.438L142.711 337.37C143.26 337.553 143.26 338.286 143.077 338.652C142.894 339.019 142.711 339.202 142.345 339.202ZM132.099 333.338C131.916 333.338 131.733 333.338 131.551 333.155L126.428 330.223C125.879 330.039 125.879 329.306 126.062 328.94C126.245 328.39 126.976 328.39 127.342 328.573L132.465 331.505C133.014 331.689 133.014 332.422 132.831 332.788C132.831 333.155 132.465 333.338 132.099 333.338ZM122.036 327.474C121.853 327.474 121.671 327.474 121.488 327.291L116.365 324.359C115.816 324.175 115.816 323.442 115.999 323.076C116.182 322.526 116.913 322.526 117.279 322.709L122.402 325.641C122.951 325.825 122.951 326.558 122.768 326.924C122.585 327.291 122.402 327.474 122.036 327.474ZM218.275 350.564C217.726 350.564 217.36 350.197 217.36 349.648V343.783C217.36 343.234 217.726 342.867 218.275 342.867C218.824 342.867 219.19 343.234 219.19 343.783V349.648C219.19 350.197 218.824 350.564 218.275 350.564ZM111.791 321.61C111.608 321.61 111.425 321.61 111.242 321.427L106.119 318.494C105.57 318.311 105.57 317.578 105.753 317.212C105.936 316.662 106.668 316.662 107.033 316.845L112.156 319.777C112.705 319.96 112.705 320.694 112.522 321.06C112.522 321.427 112.156 321.61 111.791 321.61ZM101.728 315.746C101.545 315.746 101.362 315.746 101.179 315.562L96.0557 312.63C95.5068 312.447 95.5068 311.714 95.6898 311.348C95.8727 310.798 96.6046 310.798 96.9705 310.981L102.093 313.913C102.642 314.096 102.642 314.829 102.459 315.196C102.459 315.562 102.093 315.746 101.728 315.746ZM218.275 338.836C217.726 338.836 217.36 338.469 217.36 337.919V332.055C217.36 331.505 217.726 331.139 218.275 331.139C218.824 331.139 219.19 331.505 219.19 332.055V337.919C219.19 338.469 218.824 338.836 218.275 338.836ZM91.6646 309.882C91.4816 309.882 91.2986 309.882 91.1157 309.698L85.9927 306.766C85.4438 306.583 85.4438 305.85 85.6268 305.483C85.8097 304.934 86.5416 304.934 86.9075 305.117L92.0305 308.049C92.5794 308.232 92.5794 308.965 92.3964 309.332C92.2135 309.698 91.8475 309.882 91.6646 309.882ZM81.4186 304.017C81.2357 304.017 81.0527 304.017 80.8697 303.834L77.5764 302.002C77.0275 301.635 76.2957 301.269 75.7468 300.902C75.3808 300.536 75.1979 299.986 75.3808 299.619C75.7468 299.253 76.2957 299.07 76.6616 299.253C77.2105 299.619 77.7594 299.986 78.3082 300.352L81.6016 302.185C82.1505 302.368 82.1505 303.101 81.9675 303.468C82.1505 303.834 81.7845 304.017 81.4186 304.017ZM218.275 327.107C217.726 327.107 217.36 326.741 217.36 326.191V320.327C217.36 319.777 217.726 319.411 218.275 319.411C218.824 319.411 219.19 319.777 219.19 320.327V326.191C219.19 326.741 218.824 327.107 218.275 327.107ZM71.7216 297.604C71.5386 297.604 71.1727 297.604 70.9897 297.42C69.526 296.138 68.0623 294.672 66.7816 293.206C66.4156 292.839 66.4156 292.106 66.7816 291.739C67.1475 291.373 67.8793 291.373 68.2453 291.739C69.526 293.205 70.9897 294.488 72.2705 295.771C72.6364 296.138 72.6364 296.687 72.2705 297.237C72.2705 297.42 72.0875 297.604 71.7216 297.604ZM218.275 315.379C217.726 315.379 217.36 315.013 217.36 314.463V308.599C217.36 308.049 217.726 307.683 218.275 307.683C218.824 307.683 219.19 308.049 219.19 308.599V314.463C219.19 315.013 218.824 315.379 218.275 315.379ZM63.8542 288.807C63.4882 288.807 63.3053 288.624 63.1223 288.441C62.0245 286.792 60.9267 285.142 59.829 283.493C59.463 282.943 59.646 282.394 60.1949 282.21C60.7438 281.844 61.2927 282.027 61.4756 282.577C62.3904 284.226 63.4882 285.875 64.586 287.341C64.9519 287.708 64.769 288.441 64.403 288.624C64.403 288.807 64.0371 288.807 63.8542 288.807ZM218.275 303.651C217.726 303.651 217.36 303.284 217.36 302.735V296.871C217.36 296.321 217.726 295.954 218.275 295.954C218.824 295.954 219.19 296.321 219.19 296.871V302.735C219.19 303.284 218.824 303.651 218.275 303.651ZM57.9993 278.728C57.6334 278.728 57.2675 278.545 57.0845 278.179C56.1697 276.346 55.4378 274.514 54.889 272.681C54.706 272.131 54.889 271.582 55.4378 271.398C55.9867 271.215 56.5356 271.398 56.7186 271.948C57.2675 273.781 57.9993 275.43 58.9142 277.262C59.0971 277.812 58.9141 278.362 58.3653 278.545C58.1823 278.728 57.9993 278.728 57.9993 278.728ZM218.275 292.106C217.726 292.106 217.36 291.739 217.36 291.19V285.326C217.36 284.776 217.726 284.409 218.275 284.409C218.824 284.409 219.19 284.776 219.19 285.326V291.19C219.19 291.556 218.824 292.106 218.275 292.106ZM53.9741 267.733C53.6082 267.733 53.0593 267.367 53.0593 267C52.5104 264.984 52.3275 262.969 52.1445 261.136C52.1445 260.586 52.5104 260.037 53.0593 260.037C53.6082 260.037 54.1571 260.403 54.1571 260.953C54.3401 262.785 54.706 264.618 55.0719 266.634C55.2549 267.184 54.889 267.733 54.3401 267.733C54.1571 267.733 54.1571 267.733 53.9741 267.733ZM218.275 280.378C217.726 280.378 217.36 280.011 217.36 279.461V273.597C217.36 273.048 217.726 272.681 218.275 272.681C218.824 272.681 219.19 273.048 219.19 273.597V279.461C219.19 279.828 218.824 280.378 218.275 280.378ZM218.275 268.65C217.726 268.65 217.36 268.283 217.36 267.733V261.869C217.36 261.319 217.726 260.953 218.275 260.953C218.824 260.953 219.19 261.319 219.19 261.869V267.733C219.19 268.1 218.824 268.65 218.275 268.65ZM218.275 256.921C217.726 256.921 217.36 256.555 217.36 256.005V250.141C217.36 249.591 217.726 249.225 218.275 249.225C218.824 249.225 219.19 249.591 219.19 250.141V256.005C219.19 256.372 218.824 256.921 218.275 256.921ZM52.8764 256.188C52.3275 256.188 51.9615 255.822 51.9615 255.272V249.408C51.9615 248.858 52.3275 248.492 52.8764 248.492C53.4253 248.492 53.7912 248.858 53.7912 249.408V255.272C53.9741 255.822 53.4253 256.188 52.8764 256.188ZM218.275 245.193C217.726 245.193 217.36 244.827 217.36 244.277V238.229C217.36 237.68 217.726 237.313 218.275 237.313C218.824 237.313 219.19 237.68 219.19 238.229V244.094C219.19 244.643 218.824 245.193 218.275 245.193ZM52.8764 244.46C52.3275 244.46 51.9615 244.094 51.9615 243.544V237.68C51.9615 237.13 52.3275 236.763 52.8764 236.763C53.4253 236.763 53.7912 237.13 53.7912 237.68V243.544C53.9741 244.094 53.4253 244.46 52.8764 244.46ZM218.275 233.465C217.726 233.465 217.36 233.098 217.36 232.549V226.684C217.36 226.135 217.726 225.768 218.275 225.768C218.824 225.768 219.19 226.135 219.19 226.684V232.549C219.19 232.915 218.824 233.465 218.275 233.465ZM52.8764 232.732C52.3275 232.732 51.9615 232.365 51.9615 231.816V225.951C51.9615 225.402 52.3275 225.035 52.8764 225.035C53.4253 225.035 53.7912 225.402 53.7912 225.951V231.816C53.9741 232.365 53.4253 232.732 52.8764 232.732ZM218.275 221.737C217.726 221.737 217.36 221.37 217.36 220.82V214.956C217.36 214.407 217.726 214.04 218.275 214.04C218.824 214.04 219.19 214.407 219.19 214.956V220.82C219.19 221.187 218.824 221.737 218.275 221.737ZM52.8764 221.004C52.3275 221.004 51.9615 220.637 51.9615 220.087V214.223C51.9615 213.674 52.3275 213.307 52.8764 213.307C53.4253 213.307 53.7912 213.674 53.7912 214.223V220.087C53.9741 220.637 53.4253 221.004 52.8764 221.004ZM218.275 210.008C217.726 210.008 217.36 209.642 217.36 209.092V206.527C217.36 205.427 217.36 204.328 217.177 203.228C217.177 202.678 217.543 202.129 218.092 202.129C218.641 202.129 219.19 202.495 219.19 203.045C219.373 204.144 219.373 205.244 219.373 206.527V209.092C219.19 209.459 218.824 210.008 218.275 210.008ZM52.8764 209.275C52.3275 209.275 51.9615 208.909 51.9615 208.359V202.495C51.9615 201.945 52.3275 201.579 52.8764 201.579C53.4253 201.579 53.7912 201.945 53.7912 202.495V208.359C53.9741 208.909 53.4253 209.275 52.8764 209.275ZM217.177 198.28C216.811 198.28 216.262 197.914 216.262 197.547C215.897 195.715 215.348 193.882 214.616 192.05C214.433 191.5 214.616 190.95 215.165 190.767C215.714 190.584 216.262 190.767 216.445 191.317C217.177 193.149 217.726 195.165 218.092 196.997C218.275 197.547 217.909 198.097 217.36 198.097C217.36 198.28 217.177 198.28 217.177 198.28ZM52.8764 197.547C52.3275 197.547 51.9615 197.181 51.9615 196.631V190.767C51.9615 190.217 52.3275 189.851 52.8764 189.851C53.4253 189.851 53.7912 190.217 53.7912 190.767V196.631C53.9741 197.181 53.4253 197.547 52.8764 197.547ZM213.335 187.285C212.969 187.285 212.603 187.102 212.42 186.735C211.688 185.086 210.774 183.253 209.676 181.604C209.31 181.054 209.493 180.505 210.042 180.321C210.591 180.138 211.14 180.138 211.322 180.688C212.42 182.337 213.335 184.17 214.067 186.002C214.25 186.552 214.067 187.102 213.518 187.285C213.518 187.285 213.518 187.285 213.335 187.285ZM52.8764 185.819C52.3275 185.819 51.9615 185.452 51.9615 184.903V179.039C51.9615 178.489 52.3275 178.122 52.8764 178.122C53.4253 178.122 53.7912 178.489 53.7912 179.039V184.903C53.9741 185.452 53.4253 185.819 52.8764 185.819ZM207.297 177.206C206.931 177.206 206.748 177.023 206.565 176.84C205.468 175.19 204.187 173.724 202.906 172.441C202.54 172.075 202.54 171.342 202.906 170.975C203.272 170.609 204.004 170.609 204.37 170.975C205.651 172.441 206.931 173.908 208.029 175.557C208.395 175.923 208.212 176.656 207.846 176.84C207.846 177.206 207.48 177.206 207.297 177.206ZM52.8764 174.091C52.3275 174.091 51.9615 173.724 51.9615 173.174V167.31C51.9615 166.761 52.3275 166.394 52.8764 166.394C53.4253 166.394 53.7912 166.761 53.7912 167.31V173.174C53.9741 173.724 53.4253 174.091 52.8764 174.091ZM199.43 168.593C199.247 168.593 198.881 168.593 198.698 168.41C197.234 167.127 195.771 165.844 194.124 164.928C193.758 164.562 193.575 164.012 193.758 163.645C194.124 163.279 194.673 163.096 195.039 163.279C196.685 164.378 198.149 165.478 199.796 166.944C200.162 167.31 200.162 167.86 199.796 168.41C199.979 168.41 199.796 168.593 199.43 168.593ZM52.8764 162.363C52.3275 162.363 51.9615 161.996 51.9615 161.446V155.582C51.9615 155.032 52.3275 154.666 52.8764 154.666C53.4253 154.666 53.7912 155.032 53.7912 155.582V161.446C53.9741 161.996 53.4253 162.363 52.8764 162.363ZM189.916 161.996C189.733 161.996 189.55 161.996 189.367 161.813L184.244 158.881C183.695 158.697 183.695 157.964 183.878 157.598C184.061 157.048 184.793 157.048 185.159 157.231L190.282 160.164C190.831 160.347 190.831 161.08 190.648 161.446C190.465 161.813 190.099 161.996 189.916 161.996ZM179.67 156.132C179.487 156.132 179.304 156.132 179.121 155.949L173.998 153.017C173.449 152.833 173.449 152.1 173.632 151.734C173.815 151.184 174.547 151.184 174.913 151.367L180.036 154.299C180.585 154.483 180.585 155.216 180.402 155.582C180.402 155.949 180.036 156.132 179.67 156.132ZM52.8764 150.634C52.3275 150.634 51.9615 150.268 51.9615 149.718V143.854C51.9615 143.304 52.3275 142.938 52.8764 142.938C53.4253 142.938 53.7912 143.304 53.7912 143.854V149.718C53.9741 150.268 53.4253 150.634 52.8764 150.634ZM169.607 150.268C169.424 150.268 169.241 150.268 169.058 150.085L163.935 147.153C163.386 146.969 163.386 146.236 163.569 145.87C163.752 145.32 164.484 145.32 164.85 145.503L169.973 148.435C170.522 148.619 170.522 149.352 170.339 149.718C170.156 150.085 169.973 150.268 169.607 150.268ZM159.361 144.404C159.178 144.404 158.995 144.404 158.812 144.22L153.689 141.288C153.14 141.105 153.14 140.372 153.323 140.006C153.506 139.456 154.238 139.456 154.604 139.639L159.727 142.571C160.276 142.754 160.276 143.487 160.093 143.854C160.093 144.22 159.727 144.404 159.361 144.404ZM52.8764 138.906C52.3275 138.906 51.9615 138.54 51.9615 137.99V132.126C51.9615 131.576 52.3275 131.209 52.8764 131.209C53.4253 131.209 53.7912 131.576 53.7912 132.126V137.99C53.9741 138.54 53.4253 138.906 52.8764 138.906ZM149.298 138.54C149.115 138.54 148.932 138.54 148.749 138.356L143.626 135.608C143.077 135.424 143.077 134.691 143.26 134.325C143.443 133.775 144.175 133.775 144.541 133.958L149.664 136.89C150.213 137.074 150.213 137.807 150.03 138.173C150.03 138.356 149.664 138.54 149.298 138.54ZM139.052 132.675C138.869 132.675 138.686 132.675 138.503 132.492L133.563 129.743C133.014 129.56 133.014 128.827 133.197 128.461C133.38 127.911 134.112 127.911 134.478 128.094L139.601 131.026C140.15 131.209 140.15 131.942 139.967 132.309C139.784 132.675 139.418 132.675 139.052 132.675ZM52.8764 127.361C52.3275 127.361 51.9615 126.995 51.9615 126.445V120.581C51.9615 120.031 52.3275 119.665 52.8764 119.665C53.4253 119.665 53.7912 120.031 53.7912 120.581V126.445C53.9741 126.811 53.4253 127.361 52.8764 127.361ZM128.989 126.995C128.806 126.995 128.623 126.995 128.44 126.811L123.317 123.879C122.768 123.696 122.768 122.963 122.951 122.597C123.134 122.047 123.866 122.047 124.232 122.23L129.355 125.162C129.904 125.345 129.904 126.078 129.721 126.445C129.721 126.811 129.355 126.995 128.989 126.995ZM118.926 121.131C118.743 121.131 118.56 121.131 118.377 120.947L113.254 118.015C112.705 117.832 112.705 117.099 112.888 116.732C113.071 116.183 113.803 116.183 114.169 116.366L119.292 119.298C119.841 119.481 119.841 120.214 119.658 120.581C119.475 120.947 119.109 121.131 118.926 121.131ZM52.8764 115.633C52.3275 115.633 51.9615 115.266 51.9615 114.717V111.235C51.9615 110.319 51.9615 109.586 51.9615 108.853C51.9615 108.303 52.5104 107.936 53.0593 107.936C53.6082 107.936 53.9741 108.486 53.9741 109.036C53.9741 109.769 53.9741 110.502 53.9741 111.235V114.717C53.9741 115.083 53.4253 115.633 52.8764 115.633ZM108.68 115.266C108.497 115.266 108.314 115.266 108.131 115.083L103.008 112.151C102.459 111.968 102.459 111.235 102.642 110.868C102.825 110.319 103.557 110.319 103.923 110.502L109.046 113.434C109.595 113.617 109.595 114.35 109.412 114.717C109.412 115.083 109.046 115.266 108.68 115.266ZM98.6172 109.402C98.4342 109.402 98.2512 109.402 98.0683 109.219L92.9453 106.287C92.3964 106.104 92.3964 105.371 92.5794 105.004C92.7623 104.454 93.4942 104.454 93.8601 104.638L98.9831 107.57C99.532 107.753 99.532 108.486 99.349 108.853C99.166 109.219 98.9831 109.402 98.6172 109.402ZM54.1571 103.905C53.9741 103.905 53.9741 103.905 53.7912 103.905C53.2423 103.721 53.0593 103.172 53.2423 102.622C53.9741 100.606 54.889 98.7736 56.1697 97.1243C56.5356 96.7578 57.0845 96.5746 57.6334 96.9411C57.9993 97.3076 58.1823 97.8573 57.8164 98.4071C56.7186 99.6899 55.8038 101.339 55.2549 103.172C54.889 103.721 54.523 103.905 54.1571 103.905ZM88.3712 103.538C88.1883 103.538 88.0053 103.538 87.8223 103.355L82.6994 100.423C82.1505 100.24 82.1505 99.5066 82.3334 99.1401C82.5164 98.5904 83.2483 98.5904 83.6142 98.7736L88.7372 101.706C89.286 101.889 89.286 102.622 89.1031 102.988C89.1031 103.355 88.7371 103.538 88.3712 103.538ZM78.3082 97.6741C78.1253 97.6741 77.9423 97.6741 77.9423 97.4908H77.7594C76.1127 96.5746 74.2831 95.6583 72.6364 95.1085C72.0875 94.9253 71.9045 94.3755 72.0875 93.8258C72.2705 93.276 72.8193 93.0928 73.3682 93.276C75.1979 93.8258 77.0275 94.742 78.8571 95.8416C79.406 96.0248 79.589 96.7578 79.2231 97.1243C78.8571 97.4908 78.4912 97.6741 78.3082 97.6741ZM61.4756 95.2918C61.1097 95.2918 60.7438 95.1085 60.5608 94.742C60.3779 94.1923 60.5608 93.6425 61.1097 93.4593C62.9393 92.7262 64.769 92.3597 66.9645 92.3597H67.3305C67.8793 92.3597 68.2453 92.9095 68.2453 93.276C68.2453 93.8258 67.8793 94.1923 67.3305 94.1923H67.1475C65.3179 94.1923 63.6712 94.5588 62.0245 95.2918C61.6586 95.2918 61.6586 95.2918 61.4756 95.2918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7019 219.244C82.2573 213.063 82.1322 193.179 71.4224 174.831C60.7127 156.482 43.4739 146.618 32.9185 152.799C22.3631 158.98 22.4882 178.864 33.198 197.213C43.9077 215.561 61.1465 225.425 71.7019 219.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5861 222.103C60.5609 222.103 56.3527 220.82 51.7787 218.255C36.4098 209.459 23.9683 187.835 23.9683 170.242C23.9683 157.964 30.189 149.901 40.069 149.901C44.0942 149.901 48.3024 151.184 52.8764 153.75C68.2454 162.546 80.6868 184.17 80.6868 201.762C80.6868 214.223 74.2831 222.103 64.5861 222.103ZM40.069 151.917C31.4698 151.917 25.9809 158.881 25.9809 170.242C25.9809 187.285 38.0564 207.993 52.8764 216.606C57.0846 218.988 60.9268 220.271 64.5861 220.271C73.1854 220.271 78.6743 213.307 78.6743 201.945C78.6743 184.903 66.5987 164.195 51.7787 155.582C47.7535 153.2 43.7283 151.917 40.069 151.917Z",
    fill: "url(#paint2_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.709 181.971C63.4882 178.489 57.2675 172.625 52.1445 165.661C47.0216 166.761 40.9838 165.478 34.5801 161.813L34.3971 161.63L34.763 166.211C35.8608 182.154 42.0816 195.165 52.1445 210.558L52.3275 210.741C62.2075 206.893 68.4282 201.029 69.709 186.552L70.0749 182.52L69.709 181.971ZM61.1097 186.735C60.5608 194.065 57.2675 197.181 52.3275 199.196H52.1445C47.0216 191.317 43.9112 184.719 43.3623 176.473L42.9964 174.091H43.1793C46.4727 175.923 49.583 176.656 52.1445 176.107C54.706 179.772 57.8164 182.704 61.1097 184.536H61.2927L61.1097 186.735Z",
    fill: "url(#paint3_linear_28_640)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0430839,
    d: "M429.232 545.546L110.876 365.957C99.1662 359.177 100.63 347.265 114.169 339.385L157.714 314.829C171.254 306.95 191.746 306.217 203.455 312.997L521.628 492.769C533.338 499.549 531.874 511.46 518.335 519.34L474.79 543.896C461.433 551.593 440.941 552.509 429.232 545.546Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0861678,
    d: "M429.049 545.179L111.791 365.957C100.081 359.177 101.545 347.449 115.084 339.752L157.714 315.746C171.071 308.049 191.563 307.133 203.089 313.913L520.53 492.952C532.24 499.732 530.776 511.46 517.237 519.157L474.607 543.163C461.067 551.043 440.758 551.776 429.049 545.179Z",
    fill: "#A8AEDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1293,
    d: "M429.049 544.629L112.522 365.957C100.996 359.36 102.459 347.632 115.816 339.935L157.714 316.295C171.071 308.599 191.197 307.683 202.723 314.463L519.25 493.135C530.776 499.732 529.313 511.46 515.956 519.157L474.058 542.797C460.701 550.493 440.575 551.226 429.049 544.629Z",
    fill: "#A4AADC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1723,
    d: "M429.049 544.079L113.437 365.957C102.094 359.36 103.374 347.815 116.731 340.118L157.714 317.028C170.888 309.332 190.831 308.599 202.357 315.196L517.969 493.318C529.313 499.915 528.032 511.46 514.676 519.157L473.692 542.247C460.518 549.944 440.575 550.677 429.049 544.079Z",
    fill: "#A1A6DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2154,
    d: "M429.049 543.53L114.352 365.774C103.008 359.177 104.472 347.815 117.462 340.302L157.714 317.578C170.705 310.065 190.648 309.149 201.991 315.746L516.688 493.502C528.032 500.099 526.568 511.46 513.578 518.974L473.326 541.697C460.153 549.394 440.393 550.127 429.049 543.53Z",
    fill: "#9DA2D7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2585,
    d: "M429.049 543.163L115.267 365.957C104.106 359.543 105.387 348.182 118.377 340.668L157.897 318.495C170.888 310.981 190.465 310.248 201.625 316.662L515.407 493.868C526.568 500.282 525.287 511.644 512.297 519.157L472.777 541.331C459.787 548.844 440.209 549.577 429.049 543.163Z",
    fill: "#999ED4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3016,
    d: "M429.049 542.613L115.999 365.957C104.838 359.543 106.302 348.365 119.109 340.851L157.714 319.228C170.522 311.714 189.916 310.981 201.077 317.395L514.127 494.051C525.287 500.465 523.824 511.644 511.016 519.157L472.411 540.781C459.604 548.111 440.21 549.027 429.049 542.613Z",
    fill: "#969AD1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3447,
    d: "M429.049 542.064L116.914 365.957C105.936 359.543 107.217 348.548 120.024 341.035L157.897 319.777C170.705 312.447 189.916 311.531 200.894 317.945L513.029 494.051C524.007 500.465 522.726 511.46 509.919 518.974L472.045 540.231C459.238 547.561 440.027 548.478 429.049 542.064Z",
    fill: "#9296CE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3878,
    d: "M429.049 541.514L117.828 365.957C106.851 359.727 108.314 348.548 120.939 341.401L157.897 320.694C170.522 313.363 189.55 312.63 200.528 318.861L511.748 494.601C522.726 500.832 521.262 512.01 508.638 519.157L471.679 539.865C458.872 547.012 439.844 547.928 429.049 541.514Z",
    fill: "#8E92CB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4308,
    d: "M428.866 540.964L118.56 365.957C107.765 359.727 109.046 348.731 121.671 341.584L157.897 321.243C170.339 314.096 189.184 313.18 200.162 319.411L510.467 494.601C521.262 500.832 519.982 511.827 507.357 518.974L471.13 539.315C458.689 546.462 439.844 547.195 428.866 540.964Z",
    fill: "#8B8EC8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4739,
    d: "M428.866 540.598L119.475 365.957C108.68 359.727 110.144 348.915 122.402 341.768L157.714 321.976C170.156 314.829 188.818 314.096 199.43 320.327L509.004 494.784C519.798 501.015 518.335 511.827 506.076 518.974L470.764 538.765C458.323 545.912 439.661 546.645 428.866 540.598Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.517,
    d: "M428.866 540.048L120.207 365.957C109.595 359.91 110.876 349.098 123.134 341.951L157.897 322.526C170.156 315.379 188.635 314.646 199.247 320.877L507.906 494.968C518.518 501.015 517.237 511.827 504.979 518.974L470.216 538.215C457.957 545.362 439.478 546.095 428.866 540.048Z",
    fill: "#8485C3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5601,
    d: "M428.866 539.498L121.122 365.957C110.693 359.91 111.974 349.281 124.049 342.317L157.897 323.442C169.973 316.479 188.269 315.746 198.881 321.793L506.625 495.517C517.054 501.565 515.773 512.193 503.698 519.157L469.85 538.032C457.774 544.813 439.295 545.546 428.866 539.498Z",
    fill: "#8081C0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6032,
    d: "M428.866 538.948L122.036 365.774C111.608 359.727 112.888 349.281 124.964 342.317L157.897 323.809C169.973 316.845 188.086 316.112 198.515 322.16L505.344 495.334C515.773 501.381 514.493 511.827 502.417 518.791L469.484 537.299C457.408 544.263 439.295 544.996 428.866 538.948Z",
    fill: "#7C7DBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6463,
    d: "M428.866 538.399L122.951 365.774C112.705 359.91 113.986 349.464 125.879 342.501L158.08 324.542C169.973 317.578 187.903 316.845 198.149 322.893L504.064 495.517C514.31 501.381 513.029 511.827 501.136 518.79L468.935 536.749C457.042 543.713 439.112 544.446 428.866 538.399Z",
    fill: "#7979BA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6893,
    d: "M428.866 538.032L123.683 365.774C113.437 359.91 114.718 349.648 126.611 342.867L157.897 325.458C169.607 318.678 187.537 317.945 197.6 323.809L502.6 495.884C512.846 501.748 511.565 512.01 499.673 518.791L468.386 536.2C456.859 543.163 438.929 543.896 428.866 538.032Z",
    fill: "#7575B7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7324,
    d: "M428.866 537.482L124.598 365.774C114.535 359.91 115.816 349.831 127.342 343.05L157.897 326.008C169.607 319.227 187.171 318.494 197.234 324.359L501.502 495.884C511.565 501.748 510.284 511.827 498.758 518.607L468.203 535.65C456.493 542.613 438.929 543.346 428.866 537.482Z",
    fill: "#7171B4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7755,
    d: "M428.683 536.933L125.33 365.774C115.267 360.093 116.548 349.831 128.074 343.234L157.714 326.741C169.241 320.144 186.622 319.411 196.685 325.092L500.038 496.25C510.101 501.931 508.821 512.193 497.294 518.791L467.654 535.283C456.127 542.064 438.746 542.797 428.683 536.933Z",
    fill: "#6E6DB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8186,
    d: "M428.683 536.383L126.245 365.774C116.365 360.093 117.645 350.014 128.989 343.417L157.897 327.291C169.241 320.694 186.623 319.961 196.503 325.641L498.941 496.25C508.821 501.931 507.54 512.01 496.196 518.607L467.288 534.734C455.944 541.514 438.563 542.064 428.683 536.383Z",
    fill: "#6A69AF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8617,
    d: "M428.683 535.833L127.159 365.774C117.462 360.093 118.56 350.197 129.904 343.783L158.08 328.207C169.424 321.61 186.44 321.06 196.137 326.558L497.66 496.617C507.357 502.298 506.259 512.193 494.915 518.607L466.739 534.184C455.578 540.781 438.563 541.514 428.683 535.833Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M428.683 535.467L127.891 365.774C118.194 360.093 119.475 350.381 130.636 343.967L157.897 328.757C169.058 322.343 185.891 321.61 195.588 327.107L496.379 496.617C506.076 502.298 504.795 512.01 493.635 518.424L466.373 533.634C455.212 540.231 438.38 540.964 428.683 535.467Z",
    fill: "#6361A9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M502.966 428.08H500.77C499.673 426.614 498.026 425.331 496.013 424.048L189.733 251.24C179.304 245.193 161.374 245.926 149.481 252.89L123.866 268.466C120.756 270.299 118.377 272.315 116.731 274.514H113.986V355.328C114.352 358.81 116.548 362.109 120.939 364.491L427.219 537.299C437.648 543.347 455.578 542.613 467.471 535.65L493.086 520.073C498.758 516.775 502.051 512.743 502.783 508.712H502.966V428.08Z",
    fill: "url(#paint4_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.219 458.317L120.756 285.509C110.327 279.462 111.791 269.016 123.683 262.236L149.298 246.659C161.191 239.696 179.304 238.962 189.55 245.01L496.013 417.818C506.442 423.865 504.978 434.311 493.086 441.091L467.471 456.668C455.578 463.631 437.465 464.364 427.219 458.317Z",
    fill: "url(#paint5_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.086 439.259L467.471 454.835C455.578 461.799 437.465 462.532 427.219 456.484L120.756 283.676C116.548 281.294 114.352 278.179 113.986 274.88C113.437 279.095 115.633 283.31 120.756 286.425L427.036 459.233C437.465 465.281 455.395 464.548 467.288 457.584L492.903 442.007C500.038 437.792 503.332 432.478 502.6 427.53C502.234 431.562 498.941 435.96 493.086 439.259Z",
    fill: "url(#paint6_radial_28_640)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.047619,
    d: "M174.547 257.288C178.572 254.906 184.061 253.44 189.367 253.256C193.941 253.073 198.332 254.173 201.626 256.005C201.808 256.005 209.859 260.586 209.859 260.586L343.056 336.82L353.119 342.684L484.304 417.818C488.512 420.383 491.439 424.598 491.622 428.813C491.805 433.761 488.878 438.525 483.389 441.641L471.496 447.871C471.313 447.871 461.433 453.003 461.25 453.003C457.042 455.385 451.736 456.668 446.43 456.484C441.856 456.484 437.465 455.202 434.172 453.369L302.987 376.952L294.388 371.821L171.803 300.536C167.594 297.97 164.484 293.755 164.484 289.54C164.484 284.776 166.863 280.011 171.985 276.896L172.168 273.964C172.168 273.964 174.181 257.471 174.547 257.288Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0952381,
    d: "M174.547 258.571C178.389 256.372 184.061 254.722 189.001 254.539C193.575 254.356 197.783 255.272 201.26 256.921C201.626 256.921 209.31 261.319 209.493 261.319L341.958 337.186L352.021 343.05L482.657 418.001C486.682 420.383 489.976 424.781 490.159 428.813C490.341 433.578 487.78 438.342 482.291 441.458L470.582 447.688C470.399 447.871 460.701 452.636 460.518 452.636C456.31 454.835 451.187 456.118 445.881 455.935C441.673 455.935 436.916 454.469 433.806 452.636L303.719 376.952L295.12 372.005L173.449 301.085C169.424 298.703 165.948 294.488 165.948 290.273C165.948 285.692 167.594 280.744 172.534 277.995L172.717 275.063C172.169 274.88 173.998 258.937 174.547 258.571Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M174.73 260.037C178.389 257.838 184.244 256.188 189.001 255.822C193.575 255.455 197.783 256.372 201.26 258.021C201.625 258.021 209.31 262.236 209.493 262.419L341.409 338.103L351.472 343.783L481.559 418.368C485.401 420.567 488.878 424.965 489.244 428.996C489.61 433.761 487.231 438.525 481.742 441.641L470.033 447.871C469.667 448.055 460.335 452.636 459.97 452.819C455.761 455.018 450.638 456.118 445.698 455.751C441.673 455.751 436.55 454.102 433.806 452.453L304.451 377.136L295.852 372.188L174.913 301.818C171.071 299.619 167.411 295.221 167.411 291.19C167.411 286.792 168.326 281.844 173.083 279.278V276.529C171.985 275.796 173.815 260.403 174.73 260.037Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M174.913 261.319C178.389 259.304 184.427 257.471 188.818 256.921C193.209 256.372 197.417 257.288 200.894 258.754C201.443 258.754 208.761 262.785 209.127 262.969L340.495 338.286L350.558 343.967L480.095 418.184C483.755 420.383 487.597 424.781 487.963 428.63C488.512 433.394 486.316 437.976 480.827 441.274L469.301 447.505C468.752 447.871 459.97 452.27 459.238 452.27C455.03 454.285 450.09 455.385 445.15 455.018C441.307 455.018 436.001 453.186 433.257 451.536L304.634 376.769L296.217 371.821L176.194 302.002C172.534 299.803 168.509 295.405 168.509 291.74C168.509 287.708 168.692 282.577 173.083 280.011L172.9 277.262C171.985 276.713 173.815 261.869 174.913 261.319Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M174.913 262.602C178.206 260.77 184.61 258.754 188.635 258.204C193.026 257.471 197.234 258.387 200.711 259.853C201.443 259.853 208.395 263.702 208.944 263.885L339.763 338.836L349.643 344.517L478.632 418.551C482.108 420.567 486.133 425.148 486.682 428.63C487.231 433.211 485.401 437.976 479.913 441.091L468.569 447.322C468.02 447.688 459.421 451.903 458.506 451.903C454.298 453.919 449.358 454.652 444.601 454.285C440.941 454.285 435.453 452.27 432.891 450.62L305.183 376.403L296.766 371.455L177.474 302.368C173.998 300.352 169.607 295.771 169.607 292.289C169.607 288.441 169.058 283.31 173.266 280.928L173.083 278.362C171.803 277.629 173.632 263.518 174.913 262.602Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M175.096 264.068C178.206 262.236 184.793 260.22 188.452 259.487C192.66 258.754 197.051 259.487 200.528 260.77C201.443 260.77 208.212 264.251 208.761 264.801L339.031 339.569L348.911 345.25L477.351 418.917C480.644 420.75 485.035 425.515 485.584 428.813C486.316 433.394 484.669 437.976 478.998 441.274L467.654 447.505C466.922 447.871 458.689 451.903 457.774 452.086C453.566 453.919 448.809 454.652 444.052 454.285C440.758 454.285 434.904 451.903 432.525 450.62L305.732 376.952L297.315 372.005L178.938 303.284C175.645 301.452 170.888 296.687 170.888 293.389C170.888 289.724 169.607 284.409 173.632 282.21L173.266 279.645C171.802 278.545 173.449 264.985 175.096 264.068Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M175.096 265.351C178.023 263.702 184.793 261.319 188.269 260.586C192.477 259.67 196.686 260.403 200.345 261.686C201.443 261.686 207.846 264.984 208.578 265.534L338.116 339.935L347.996 345.616L475.704 418.917C478.632 420.567 484.121 425.514 484.121 428.63C485.767 433.028 483.572 437.792 477.9 440.908L466.739 447.138C465.824 447.688 457.957 451.353 456.859 451.536C452.651 453.186 447.894 453.919 443.32 453.369C440.21 453.369 434.172 450.803 431.976 449.521L306.098 376.403L297.681 371.638L180.036 303.284C177.109 301.635 171.803 296.871 171.803 293.755C171.803 290.457 169.79 284.959 173.449 282.943L172.9 280.561C171.62 279.462 173.266 266.451 175.096 265.351Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M175.279 266.634C177.84 265.168 184.976 262.602 188.269 261.686C192.294 260.586 196.686 261.319 200.162 262.419C201.443 262.419 207.663 265.534 208.395 266.084L337.384 340.118L347.264 345.799L474.424 418.734C477.168 420.383 483.023 425.331 483.023 428.08C484.853 432.295 482.84 437.06 477.168 440.358L466.19 446.589C465.093 447.138 457.591 450.804 456.31 450.804C452.285 452.453 447.528 453.003 443.137 452.453C440.21 452.453 433.989 449.704 431.793 448.421L306.829 375.853L298.596 371.088L181.865 303.284C179.121 301.635 173.449 296.871 173.449 293.939C173.449 290.823 170.888 285.326 174.181 283.31L173.632 280.928C171.437 280.378 173.083 267.917 175.279 266.634Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M175.279 267.917C177.657 266.45 184.976 263.885 187.903 262.969C191.928 261.869 196.137 262.419 199.796 263.518C201.077 263.518 207.114 266.45 208.212 267L336.652 340.851L346.349 346.532L472.96 419.284C475.521 420.75 481.742 425.881 481.742 428.447C483.938 432.478 481.925 437.426 476.253 440.725L465.276 447.138C464.178 447.871 456.859 451.17 455.395 451.353C451.37 452.819 446.613 453.369 442.405 452.636C439.661 452.636 433.257 449.704 431.244 448.604L307.012 376.586L298.779 371.821L183.146 304.201C180.585 302.735 174.547 297.787 174.547 295.221C174.547 292.289 171.254 286.792 174.364 284.959L173.632 282.76C171.437 281.294 172.9 269.383 175.279 267.917Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M175.462 269.383C177.657 268.1 185.159 265.168 187.903 264.251C191.745 262.969 196.137 263.518 199.796 264.435C201.26 264.435 207.114 267.184 208.212 267.917L336.103 341.401L345.801 347.082L471.862 419.467C474.241 420.75 480.827 426.064 480.827 428.447C483.206 432.478 481.376 437.426 475.704 440.541L464.91 446.955C463.629 447.688 456.676 450.804 455.213 450.987C451.187 452.453 446.613 452.819 442.405 452.086C440.027 452.086 433.074 448.971 431.427 447.871L308.11 376.403L299.877 371.638L184.793 304.934C182.414 303.651 176.194 298.52 176.194 296.138C176.194 293.572 172.168 287.708 174.913 286.059L173.998 283.86C171.254 282.21 172.717 270.849 175.462 269.383Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5238,
    d: "M175.462 270.665C177.474 269.566 185.159 266.267 187.537 265.351C191.38 263.885 195.588 264.435 199.247 265.351C200.894 265.351 206.383 267.917 207.663 268.65L335.006 341.768L344.703 347.265L470.216 419.284C472.411 420.567 479.364 425.881 479.364 428.08C481.925 431.928 480.278 436.876 474.607 440.175L463.995 446.589C462.531 447.322 455.944 450.437 454.298 450.437C450.273 451.72 445.698 452.086 441.673 451.353C439.478 451.353 432.342 448.055 430.878 447.138L308.476 376.219L300.426 371.455L186.257 305.117C184.061 303.834 177.474 298.703 177.474 296.504C177.474 294.122 172.717 288.258 175.279 286.792L174.181 284.593C171.254 283.127 172.534 272.498 175.462 270.665Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5714,
    d: "M175.645 271.948C177.474 270.849 185.342 267.55 187.537 266.634C191.197 264.984 195.588 265.534 199.247 266.267C201.077 266.267 206.383 268.65 207.663 269.383L334.274 342.134L343.971 347.632L468.935 419.467C470.947 420.567 478.266 426.064 478.266 427.897C481.193 431.745 479.364 436.693 473.875 439.808L463.263 446.222C461.799 447.138 455.396 449.887 453.566 450.07C449.541 451.353 445.15 451.536 441.124 450.62C439.112 450.62 431.793 446.955 430.33 446.222L308.842 375.853L300.792 371.271L187.354 305.483C185.342 304.384 178.389 299.07 178.389 297.237C178.389 295.038 172.9 289.174 175.279 287.708L174.181 285.692C171.071 284.043 172.351 273.964 175.645 271.948Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.619,
    d: "M175.828 273.231C177.474 272.315 185.525 268.65 187.354 267.733C191.014 266.084 195.405 266.451 199.064 267.184C201.077 267.184 206.017 269.383 207.48 270.116L333.542 342.684L343.056 348.182L467.288 419.65C468.935 420.567 476.802 426.064 476.802 427.897C479.913 431.562 478.266 436.51 472.594 439.808L462.165 446.222C460.518 447.138 454.481 449.704 452.468 449.887C448.443 450.987 444.052 451.17 440.392 450.254C438.563 450.254 431.061 446.405 429.781 445.672L309.208 375.853L301.157 371.271L188.635 306.033C186.988 305.117 179.487 299.803 179.487 297.97C179.487 296.138 173.266 289.907 175.279 288.807L173.998 286.792C170.888 284.959 172.168 275.43 175.828 273.231Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M175.828 274.697C177.291 273.964 185.525 269.932 187.171 269.016C190.648 267.184 195.039 267.55 198.698 268.1C200.711 268.1 205.468 270.116 207.114 271.032L332.627 343.234L342.141 348.731L465.824 419.834C467.288 420.75 475.521 426.248 475.521 427.897C478.815 431.562 477.351 436.51 471.679 439.808L461.433 446.222C459.604 447.322 454.115 449.521 451.919 449.704C447.894 450.803 443.686 450.803 440.027 449.704C438.38 449.704 430.695 445.672 429.598 445.123L309.757 375.67L301.889 371.088L190.099 306.4C188.635 305.484 180.768 300.169 180.768 298.703C180.768 297.054 173.815 290.823 175.645 289.724L174.181 287.891C170.888 285.875 171.985 276.896 175.828 274.697Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M176.011 275.98C177.291 275.247 185.708 271.032 186.989 270.116C190.282 268.1 194.856 268.466 198.515 269.016C200.711 269.016 205.285 270.849 206.932 271.765L331.895 343.6L341.41 349.098L464.544 420.017C465.824 420.75 474.424 426.431 474.424 427.714C478.083 431.195 476.619 436.143 470.947 439.442L460.702 445.856C458.872 446.955 453.566 449.154 451.187 449.337C447.162 450.254 442.954 450.254 439.478 449.154C438.197 449.154 430.147 444.939 429.049 444.39L310.123 375.67L302.255 371.088L191.38 306.95C190.099 306.217 181.866 300.719 181.866 299.436C181.866 297.97 174.181 291.739 175.828 290.823L174.364 288.991C170.705 286.792 171.803 278.362 176.011 275.98Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7619,
    d: "M176.011 277.262C177.108 276.713 185.525 271.398 186.805 271.398C190.465 269.932 194.49 269.566 198.332 269.932C200.711 269.932 204.919 271.582 206.748 272.498L331.163 344.15L340.678 349.648L463.263 420.2C464.361 420.75 473.326 426.614 473.326 427.714C477.168 431.195 475.887 436.143 470.215 439.442L460.152 445.856C458.14 446.955 453.2 448.971 450.638 449.154C446.613 449.887 442.588 449.887 439.112 448.604C438.014 448.604 429.781 444.206 428.866 443.657L310.855 375.486L302.987 370.905L192.843 307.133C191.745 306.583 183.146 300.902 183.146 299.803C183.146 298.52 174.73 292.289 176.011 291.556L174.364 289.907C170.705 287.708 171.619 279.828 176.011 277.262Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8095,
    d: "M176.194 278.729C176.925 278.179 185.708 272.681 186.805 272.681C190.282 271.215 194.49 270.665 198.332 271.032C200.894 271.032 204.919 272.498 206.748 273.597L330.432 344.883L339.946 350.381L461.982 420.567C462.897 421.116 472.228 426.981 472.228 427.897C476.253 431.195 475.156 436.143 469.484 439.625L459.604 446.039C457.408 447.322 452.834 448.971 450.09 449.154C446.247 449.887 442.039 449.704 438.929 448.421C438.014 448.421 429.415 443.84 428.866 443.473L311.769 375.853L304.085 371.455L194.307 307.866C193.392 307.316 184.427 301.635 184.427 300.902C184.427 299.986 175.279 293.389 176.377 292.839L174.547 291.19C170.522 288.807 171.437 281.294 176.194 278.729Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8571,
    d: "M176.194 280.011C176.743 279.645 185.708 273.781 186.44 273.781C189.916 272.131 193.941 271.582 197.783 271.765C200.528 271.765 204.187 273.048 206.2 274.147L329.334 345.066L338.665 350.381L460.153 420.383C460.884 420.75 470.581 426.797 470.581 427.347C474.973 430.646 473.875 435.593 468.203 438.892L458.323 445.489C455.944 446.772 451.736 448.421 448.992 448.604C445.15 449.154 441.124 448.788 438.014 447.505C437.282 447.505 428.5 442.557 428.134 442.374L311.952 375.303L304.268 370.905L195.771 308.232C195.039 307.866 185.891 302.185 185.891 301.452C185.891 300.719 176.011 294.122 176.743 293.755L174.913 292.289C170.522 289.724 171.254 282.943 176.194 280.011Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M176.377 281.294C176.743 281.111 185.891 275.063 186.44 275.063C189.733 273.414 193.941 272.681 197.783 272.864C200.711 272.864 204.187 273.964 206.2 275.063L328.785 345.799L338.116 351.114L458.872 420.75C459.238 420.933 469.484 427.164 469.484 427.53C474.058 430.646 473.143 435.777 467.471 439.075L457.774 445.672C455.396 447.138 451.37 448.421 448.443 448.604C444.601 449.154 440.576 448.604 437.648 447.322C437.282 447.322 428.134 442.191 427.768 442.007L312.501 375.303L304.817 370.905L197.234 308.782C196.869 308.599 187.171 302.735 187.171 302.185C187.171 301.635 176.56 295.038 177.109 294.672L175.096 293.206C170.339 290.64 171.071 284.409 176.377 281.294Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9524,
    d: "M176.377 282.577C176.56 282.394 185.891 276.163 186.074 276.163C189.367 274.33 193.575 273.597 197.417 273.597C200.345 273.597 203.638 274.514 205.834 275.613L327.87 345.983L337.201 351.297L457.408 420.567C457.591 420.75 468.203 426.981 468.203 427.164C472.96 430.096 472.228 435.227 466.373 438.526L456.859 445.123C454.298 446.589 450.638 447.688 447.528 447.871C443.686 448.238 439.844 447.688 436.916 446.222C436.733 446.222 427.402 440.908 427.219 440.908L312.867 375.12L305.366 370.722L198.515 309.149C198.332 308.965 188.269 303.101 188.269 302.918C188.269 302.735 176.925 295.954 177.291 295.771L175.096 294.305C170.156 291.556 170.888 285.875 176.377 282.577Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.55 446.039L305.915 370.722L175.279 295.405C170.156 292.473 170.888 287.341 176.743 284.043L186.257 277.446C192.111 274.147 200.894 273.781 205.834 276.713L336.469 352.03L467.105 427.347C472.228 430.279 471.496 435.41 465.641 438.709L456.127 445.306C450.272 448.604 441.49 448.971 436.55 446.039Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M437.282 444.206L182.597 297.42C168.143 288.991 156.434 266.634 156.434 247.209V30.0536C156.434 10.6287 168.143 1.83254 182.597 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 443.657 451.736 452.453 437.282 444.206Z",
    fill: "url(#paint7_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.967 435.593L185.708 286.242C173.632 278.545 166.314 263.335 166.314 247.575V22.3569C166.314 18.6919 170.339 16.3096 173.449 18.1421C173.815 18.3253 174.181 18.5086 174.364 18.6919L433.806 168.227C448.077 176.473 453.2 191.133 453.2 206.893V431.379C453.2 435.41 448.992 437.792 445.515 435.96C445.333 435.777 445.15 435.593 444.967 435.593Z",
    fill: "url(#paint8_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.806 168.227L174.364 18.6919C174.181 18.5086 173.815 18.3253 173.449 18.1421C170.339 16.3096 166.314 18.5086 166.314 22.3569V247.575C166.314 263.152 173.815 278.545 185.708 286.242L444.967 435.593C445.15 435.593 445.332 435.777 445.515 435.96C448.992 437.976 453.2 435.41 453.2 431.379V206.893C453.383 191.317 448.077 176.656 433.806 168.227ZM450.273 431.379C450.273 432.661 449.175 433.578 448.077 433.578C447.711 433.578 447.345 433.394 446.979 433.211L187.171 283.493C176.377 276.529 169.241 262.419 169.241 247.575V22.3569C169.241 21.2574 170.156 20.5244 171.071 20.5244C171.437 20.5244 171.62 20.5244 171.985 20.7076L432.342 170.792C447.162 179.405 450.273 194.982 450.273 206.71V431.379Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.358 149.901L194.673 3.11531C189.001 -0.183253 183.695 -0.733014 179.304 0.916267C178.755 1.09952 166.862 8.06315 166.314 8.42966C170.888 6.23062 176.56 6.59712 182.597 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 467.288 438.159 467.471 437.976C472.411 434.494 475.521 427.347 475.521 417.268V200.113C475.521 180.688 463.812 158.331 449.358 149.901Z",
    fill: "url(#paint9_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.175 150.085L194.49 3.29856C188.818 -7.45058e-08 183.512 -0.54976 179.121 1.09952C178.572 1.28277 166.862 8.06315 166.314 8.42966C170.888 6.23062 176.56 6.59712 182.597 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 466.922 438.342 467.288 437.976C472.228 434.494 475.338 427.347 475.338 417.268V200.296C475.338 180.871 463.629 158.514 449.175 150.085Z",
    fill: "url(#paint10_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.992 150.268L194.307 3.48182C188.635 0.183254 183.329 -0.366507 178.938 1.28277C178.389 1.46603 166.862 8.24641 166.314 8.42966C170.888 6.23062 176.56 6.59712 182.597 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 466.739 438.342 467.105 438.159C472.045 434.677 475.156 427.53 475.156 417.451V200.479C475.156 181.054 463.446 158.514 448.992 150.268Z",
    fill: "url(#paint11_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.626 150.268L194.124 3.66507C188.452 0.366507 183.146 -0.183253 178.755 1.46603C178.206 1.64928 166.862 8.2464 166.314 8.42966C170.888 6.23062 176.56 6.59712 182.597 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 466.556 438.525 466.922 438.342C471.862 434.86 474.973 427.714 474.973 417.635V200.479C474.973 181.238 463.263 158.697 448.626 150.268Z",
    fill: "url(#paint12_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.443 150.451L193.941 3.66507C188.269 0.366507 182.963 -0.183253 178.572 1.46603C178.023 1.64928 166.863 8.06315 166.497 8.42966C171.071 6.23062 176.743 6.59712 182.78 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 466.373 438.709 466.556 438.526C471.496 435.044 474.607 427.897 474.607 417.818V200.663C474.79 181.421 462.897 158.881 448.443 150.451Z",
    fill: "url(#paint13_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.26 150.634L193.575 3.84832C187.903 0.54976 182.597 -5.96046e-08 178.206 1.64928C177.657 1.83253 166.862 8.06315 166.314 8.42966C170.888 6.23062 176.56 6.59712 182.597 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 466.19 438.892 466.373 438.709C471.313 435.227 474.424 428.08 474.424 418.001V200.846C474.424 181.421 462.714 159.064 448.26 150.634Z",
    fill: "url(#paint14_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.077 150.818L193.392 4.03158C187.72 0.733014 182.414 0.183254 178.023 1.83253C177.474 2.01579 166.862 8.06315 166.314 8.42966C170.888 6.23062 176.56 6.59712 182.597 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 465.824 439.075 466.19 438.709C471.13 435.227 474.241 428.08 474.241 418.001V201.029C474.241 181.604 462.531 159.247 448.077 150.818Z",
    fill: "url(#paint15_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.894 151.001L193.209 4.21483C187.537 0.916267 182.231 0.366507 177.84 2.01579C177.291 2.19904 166.862 8.2464 166.314 8.42966C170.888 6.23062 176.56 6.59712 182.597 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 465.641 439.075 466.007 438.892C470.947 435.41 474.058 428.263 474.058 418.184V201.212C474.058 181.787 462.348 159.247 447.894 151.001Z",
    fill: "url(#paint16_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.528 151.001L193.026 4.39808C187.354 1.09952 182.048 0.54976 177.657 2.19904C177.108 2.38229 166.862 8.2464 166.314 8.42966C170.888 6.23062 176.56 6.59712 182.597 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 465.458 439.258 465.824 439.075C470.764 435.593 473.875 428.447 473.875 418.368V201.212C473.875 181.971 462.165 159.43 447.528 151.001Z",
    fill: "url(#paint17_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.345 151.184L192.66 4.39808C186.988 1.09952 181.683 0.54976 177.291 2.19904C176.743 2.38229 166.862 8.06315 166.314 8.42966C170.888 6.23062 176.56 6.59712 182.597 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 465.275 439.442 465.458 439.258C470.398 435.777 473.509 428.63 473.509 418.551V201.396C473.692 182.154 461.799 159.614 447.345 151.184Z",
    fill: "url(#paint18_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.162 151.367L192.477 4.58134C186.805 1.28277 181.5 0.733014 177.108 2.38229C176.56 2.56555 166.862 8.06315 166.314 8.42966C170.888 6.23062 176.56 6.59712 182.597 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 464.91 439.625 465.275 439.259C470.215 435.777 473.326 428.63 473.326 418.551V201.579C473.326 182.154 461.616 159.797 447.162 151.367Z",
    fill: "url(#paint19_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.979 151.551L192.294 4.76459C186.623 1.46603 181.317 0.916267 176.925 2.56555C176.377 2.7488 166.862 8.06315 166.314 8.42966C170.888 6.23062 176.56 6.59712 182.597 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 464.727 439.808 465.092 439.442C470.032 435.96 473.143 428.813 473.143 418.734V201.762C473.143 182.337 461.433 159.98 446.979 151.551Z",
    fill: "url(#paint20_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.796 151.734L192.111 4.94784C186.44 1.64928 181.134 1.09952 176.742 2.7488C176.194 2.93206 166.862 8.2464 166.314 8.42966C170.888 6.23062 176.56 6.59712 182.597 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 464.544 439.808 464.91 439.625C469.85 436.143 472.96 428.996 472.96 418.917V201.945C472.96 182.52 461.25 159.98 446.796 151.734Z",
    fill: "url(#paint21_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.43 151.734L191.928 5.1311C186.257 1.83253 180.951 1.28277 176.56 2.93206C176.011 3.11531 166.863 8.24641 166.497 8.42966C171.071 6.23062 176.743 6.59712 182.78 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 464.361 439.992 464.727 439.808C469.667 436.326 472.777 429.18 472.777 419.101V201.945C472.777 182.704 461.067 160.164 446.43 151.734Z",
    fill: "url(#paint22_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.247 151.917L191.563 5.1311C185.891 1.83253 180.585 1.28277 176.194 2.93206C175.645 3.11531 166.862 8.06315 166.314 8.42966C170.888 6.23062 176.56 6.59712 182.597 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 464.178 440.175 464.361 439.992C469.301 436.51 472.411 429.363 472.411 419.284V202.129C472.594 182.887 460.701 160.347 446.247 151.917Z",
    fill: "url(#paint23_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.064 152.1L191.38 5.31435C185.708 2.01579 180.402 1.46603 176.011 3.11531C175.462 3.29856 166.862 8.06315 166.314 8.42966C170.888 6.23062 176.56 6.59712 182.597 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 463.812 440.358 464.178 439.992C469.118 436.51 472.228 429.363 472.228 419.284V202.312C472.228 182.887 460.518 160.53 446.064 152.1Z",
    fill: "url(#paint24_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.881 152.284L191.197 5.4976C185.525 2.19904 180.219 1.64928 175.828 3.29856C175.279 3.48182 166.862 8.06315 166.314 8.42966C170.888 6.23062 176.56 6.59712 182.597 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 463.629 440.358 463.995 440.175C468.935 436.693 472.045 429.546 472.045 419.467V202.495C472.045 183.07 460.335 160.713 445.881 152.284Z",
    fill: "url(#paint25_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.515 152.467L191.014 5.68086C185.342 2.38229 180.036 1.83253 175.645 3.48182C175.096 3.66507 166.862 8.24641 166.314 8.42966C170.888 6.23062 176.56 6.59712 182.597 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 463.446 440.541 463.812 440.358C468.752 436.876 471.862 429.729 471.862 419.65V202.678C471.862 183.253 460.152 160.713 445.515 152.467Z",
    fill: "url(#paint26_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.333 152.467L190.831 5.86411C185.159 2.56555 179.853 2.01579 175.462 3.66507C174.913 3.84832 166.863 8.2464 166.497 8.42966C171.071 6.23062 176.743 6.59712 182.78 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 463.263 440.725 463.629 440.541C468.569 437.059 471.679 429.913 471.679 419.834V202.678C471.679 183.437 459.787 160.897 445.333 152.467Z",
    fill: "url(#paint27_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.15 152.65L190.465 5.86411C184.793 2.56555 179.487 2.01579 175.096 3.66507C174.547 3.84832 166.862 8.06315 166.314 8.42966C170.888 6.23062 176.56 6.59712 182.597 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 463.08 440.908 463.263 440.725C468.203 437.243 471.313 430.096 471.313 420.017V202.862C471.313 183.62 459.604 161.08 445.15 152.65Z",
    fill: "url(#paint28_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.967 152.833L190.282 6.04736C184.61 2.7488 179.304 2.19904 174.913 3.84832C174.364 4.03158 166.862 8.06315 166.314 8.42966C170.888 6.23062 176.56 6.59712 182.597 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 462.714 441.091 463.08 440.725C468.02 437.243 471.13 430.096 471.13 420.017V203.045C471.13 183.62 459.421 161.263 444.967 152.833Z",
    fill: "url(#paint29_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.784 153.017L190.099 6.23062C184.427 2.93206 179.121 2.38229 174.73 4.03158C174.181 4.21483 166.862 8.06315 166.314 8.42966C170.888 6.23062 176.56 6.59712 182.597 10.2622L437.282 156.865C451.736 165.295 463.446 187.652 463.446 207.076V424.232C463.446 436.326 458.872 444.39 451.919 446.589C452.468 446.589 453.2 446.405 454.298 445.856C454.664 445.672 462.531 441.091 462.897 440.908C467.837 437.426 470.947 430.279 470.947 420.2V203.228C470.947 183.803 459.238 161.263 444.784 153.017Z",
    fill: "url(#paint30_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.563 156.315L183.878 9.52918C178.023 6.04736 172.534 5.68086 168.143 7.51339C171.985 6.96363 176.194 7.8799 180.768 10.4454L435.452 157.231C449.907 165.661 461.616 188.018 461.616 207.443V424.598C461.616 435.96 457.591 443.84 451.187 446.405C459.238 445.123 464.727 436.876 464.727 423.499V206.527C464.727 187.102 453.017 164.745 438.563 156.315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.047619,
    d: "M128.806 450.07C132.099 448.238 136.491 446.955 140.699 446.955C144.358 446.772 147.834 447.688 150.579 449.154C150.762 449.154 157.165 452.819 157.165 452.819L264.565 514.392L272.798 519.157L378.551 579.814C382.027 581.83 384.406 585.311 384.406 588.793C384.589 592.825 382.21 596.49 377.819 599.056L368.122 604.003C367.939 604.003 360.072 608.035 359.889 608.035C356.412 609.867 352.204 610.967 347.996 610.967C344.337 610.967 340.678 610.051 338.116 608.401L232.363 546.828L225.411 542.797L126.611 485.255C123.134 483.239 120.756 479.941 120.756 476.276C120.756 472.427 122.768 468.579 126.794 466.197L126.976 463.814C126.976 463.448 128.623 450.254 128.806 450.07Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0952381,
    d: "M128.989 451.17C132.099 449.337 136.674 448.055 140.699 447.871C144.358 447.688 147.834 448.421 150.579 449.887C150.762 449.887 157.165 453.369 157.165 453.552L264.016 514.759L272.066 519.34L377.453 579.631C380.746 581.463 383.308 584.945 383.491 588.427C383.674 592.275 381.478 596.123 377.087 598.689L367.573 603.637C367.39 603.82 359.706 607.668 359.34 607.668C355.863 609.501 351.838 610.417 347.63 610.234C344.154 610.234 340.312 609.134 337.933 607.668L232.912 546.462L225.96 542.43L127.891 485.255C124.598 483.423 121.854 479.941 121.854 476.459C121.854 472.794 123.134 468.762 127.159 466.563L127.342 464.181C126.976 464.181 128.44 451.536 128.989 451.17Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M128.989 452.27C131.917 450.62 136.674 449.154 140.516 448.788C144.175 448.421 147.651 449.154 150.396 450.62C150.762 450.62 156.8 453.919 157.165 454.102L263.65 515.125L271.7 519.707L376.538 579.814C379.649 581.646 382.393 585.128 382.759 588.427C383.125 592.275 381.112 596.124 376.721 598.689L367.39 603.637C367.024 603.82 359.706 607.485 359.34 607.485C355.863 609.134 351.838 610.051 347.813 609.867C344.52 609.867 340.495 608.585 338.116 607.119L233.827 546.462L226.874 542.43L129.355 485.805C126.245 483.972 123.317 480.491 123.317 477.375C123.317 473.893 124.049 469.862 127.891 467.663V465.464C126.794 465.097 128.257 452.636 128.989 452.27Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M128.989 453.369C131.734 451.72 136.674 450.254 140.333 449.887C143.809 449.521 147.286 450.07 150.213 451.353C150.762 451.353 156.617 454.469 156.983 454.835L262.918 515.492L270.969 520.073L375.441 579.997C378.368 581.646 381.478 585.312 381.844 588.427C382.21 592.275 380.564 595.94 375.99 598.506L366.658 603.454C366.292 603.637 359.157 607.302 358.608 607.302C355.315 608.951 351.107 609.684 347.264 609.501C344.154 609.501 339.946 608.035 337.75 606.752L234.01 546.462L226.874 542.43L130.087 486.171C127.16 484.522 123.866 480.857 123.866 477.925C123.866 474.626 124.049 470.595 127.525 468.396L127.343 466.197C126.794 465.83 128.257 453.919 128.989 453.369Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M129.172 454.469C131.734 453.003 136.856 451.353 140.15 450.804C143.626 450.254 147.102 450.987 149.847 452.086C150.396 452.086 156.068 455.202 156.617 455.385L262.003 515.858L270.054 520.44L373.977 579.997C376.721 581.646 380.015 585.312 380.38 588.244C380.929 591.909 379.283 595.757 374.892 598.323L365.743 603.454C365.195 603.82 358.242 607.119 357.693 607.119C354.4 608.768 350.375 609.318 346.532 609.134C343.605 609.134 339.214 607.485 337.201 606.202L234.193 546.279L227.423 542.247L131.368 486.355C128.623 484.705 124.964 481.04 124.964 478.292C124.964 475.176 124.598 470.961 127.891 469.129L127.708 466.93C126.611 466.563 128.074 455.018 129.172 454.469Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M129.172 455.568C131.551 454.102 136.857 452.453 139.967 451.903C143.443 451.353 146.92 451.903 149.664 453.003C150.396 453.003 155.885 455.935 156.434 456.118L261.454 516.408L269.505 520.99L373.062 580.364C375.624 581.83 379.283 585.678 379.649 588.427C380.198 592.092 378.917 595.94 374.343 598.506L365.195 603.637C364.646 604.003 357.876 607.302 357.144 607.302C353.851 608.768 349.826 609.501 346.166 609.134C343.422 609.134 338.848 607.302 336.835 606.202L234.559 546.828L227.789 542.797L132.282 487.271C129.721 485.805 125.879 481.957 125.879 479.391C125.879 476.459 124.964 472.244 128.074 470.412L127.708 468.396C126.611 467.296 127.891 456.301 129.172 455.568Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M129.355 456.668C131.734 455.385 137.04 453.552 139.967 452.819C143.26 452.086 146.737 452.636 149.664 453.736C150.579 453.736 155.702 456.484 156.434 456.851L260.906 516.775L268.773 521.356L371.781 580.547C374.16 582.013 378.551 585.861 378.551 588.244C379.832 591.725 378.002 595.574 373.611 598.139L364.646 603.27C363.914 603.637 357.51 606.752 356.595 606.752C353.302 608.218 349.46 608.768 345.801 608.218C343.239 608.218 338.482 606.202 336.652 605.103L235.108 546.095L228.338 542.247L133.563 487.271C131.185 485.805 126.977 481.957 126.977 479.574C126.977 476.826 125.513 472.427 128.257 470.778L127.891 468.762C126.428 468.029 127.708 457.401 129.355 456.668Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M129.355 457.584C131.551 456.301 137.222 454.285 139.784 453.736C143.077 452.819 146.554 453.369 149.481 454.285C150.396 454.285 155.519 456.851 156.251 457.217L260.357 516.958L268.224 521.539L370.866 580.364C373.062 581.646 377.819 585.678 377.819 587.877C379.283 591.359 377.636 595.207 373.062 597.773L364.097 602.904C363.182 603.454 357.144 606.202 356.229 606.386C352.936 607.668 349.094 608.218 345.617 607.668C343.239 607.668 338.299 605.469 336.469 604.553L235.657 545.912L228.887 542.064L134.844 487.454C132.648 486.171 128.074 482.323 128.074 479.941C128.074 477.375 125.879 472.977 128.623 471.328L128.074 469.495C126.428 468.762 127.525 458.683 129.355 457.584Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M129.538 458.683C131.551 457.584 137.405 455.385 139.784 454.652C143.077 453.736 146.371 454.102 149.298 455.018C150.396 455.018 155.153 457.401 156.068 457.95L259.625 517.508L267.492 522.089L369.586 580.73C371.598 582.013 376.721 586.045 376.721 588.06C378.551 591.359 376.721 595.207 372.33 597.956L363.548 603.087C362.633 603.637 356.778 606.386 355.68 606.386C352.387 607.668 348.545 608.035 345.252 607.485C343.056 607.485 337.75 605.103 336.286 604.187L235.84 546.095L229.253 542.247L135.759 488.004C133.746 486.721 128.806 482.873 128.806 480.674C128.806 478.291 126.062 473.893 128.623 472.427L128.074 470.595C126.245 469.495 127.525 459.966 129.538 458.683Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M129.538 459.783C131.368 458.683 137.405 456.301 139.601 455.568C142.711 454.469 146.188 455.018 149.115 455.751C150.396 455.751 154.97 457.95 155.885 458.5L258.893 517.691L266.76 522.272L368.305 580.73C370.135 581.83 375.441 586.045 375.441 587.877C377.453 591.176 375.807 595.024 371.232 597.59L362.45 602.721C361.352 603.27 355.864 605.836 354.583 606.019C351.289 607.119 347.63 607.485 344.337 606.935C342.324 606.935 336.835 604.37 335.555 603.637L236.206 545.912L229.619 542.064L136.857 488.187C135.027 487.088 129.904 483.056 129.904 481.04C129.904 478.841 126.611 474.26 128.989 472.977L128.257 471.145C126.245 470.228 127.342 461.066 129.538 459.783Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5238,
    d: "M129.721 460.882C131.368 459.966 137.588 457.401 139.418 456.668C142.528 455.568 146.005 455.935 148.932 456.668C150.213 456.668 154.787 458.683 155.702 459.233L258.344 518.241L266.212 522.639L367.39 580.73C369.037 581.646 374.709 586.045 374.709 587.694C376.904 590.809 375.441 594.841 370.866 597.406L362.267 602.537C361.169 603.27 355.863 605.653 354.4 605.653C351.106 606.752 347.447 606.935 344.337 606.386C342.507 606.386 336.835 603.637 335.555 602.904L236.937 545.729L230.351 541.88L138.32 488.554C136.674 487.637 131.185 483.423 131.185 481.59C131.185 479.574 127.342 474.993 129.355 473.71L128.623 472.061C126.062 470.961 127.159 462.348 129.721 460.882Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5714,
    d: "M129.721 461.982C131.185 461.066 137.588 458.317 139.235 457.584C142.162 456.301 145.639 456.668 148.749 457.401C150.213 457.401 154.421 459.416 155.519 459.966L257.612 518.607L265.297 523.005L365.926 580.913C367.573 581.83 373.428 586.228 373.428 587.694C375.807 590.809 374.343 594.657 369.769 597.406L361.169 602.537C359.889 603.27 354.949 605.469 353.302 605.653C350.009 606.569 346.532 606.752 343.422 606.019C341.775 606.019 335.921 603.087 334.823 602.537L236.754 545.729L230.168 541.881L138.686 488.92C137.04 488.004 131.368 483.789 131.368 482.323C131.368 480.674 126.977 475.726 128.806 474.626L127.891 472.977C126.062 471.694 126.977 463.448 129.721 461.982Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.619,
    d: "M129.721 463.081C131.002 462.348 137.588 459.416 139.052 458.683C141.979 457.401 145.456 457.584 148.383 458.134C150.03 458.134 154.055 459.966 155.153 460.516L256.88 518.974L264.565 523.372L364.829 581.097C366.292 581.83 372.513 586.411 372.513 587.694C375.075 590.626 373.794 594.657 369.22 597.223L360.803 602.354C359.523 603.087 354.583 605.103 353.119 605.286C349.826 606.202 346.349 606.386 343.422 605.469C341.958 605.469 335.92 602.354 334.823 601.804L237.486 545.362L231.083 541.697L140.333 489.103C138.869 488.37 133.014 483.972 133.014 482.69C133.014 481.224 127.891 476.276 129.721 475.359L128.623 473.71C125.879 472.427 126.976 464.731 129.721 463.081Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M129.904 464.181C131.002 463.448 137.771 460.333 139.052 459.6C141.796 458.134 145.456 458.317 148.383 458.867C150.03 458.867 153.872 460.516 155.153 461.249L256.331 519.524L264.016 523.922L363.731 581.28C365.012 582.013 371.598 586.411 371.598 587.694C374.343 590.626 373.062 594.657 368.488 597.223L360.072 602.354C358.608 603.27 354.034 605.103 352.387 605.286C349.094 606.019 345.617 606.202 342.873 605.286C341.592 605.286 335.372 601.988 334.457 601.621L237.852 545.546L231.448 541.88L141.431 489.653C140.15 488.92 133.929 484.522 133.929 483.423C133.929 482.14 128.257 477.009 129.721 476.276L128.623 474.81C125.879 473.16 126.794 465.83 129.904 464.181Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M129.904 465.097C130.819 464.548 137.771 461.066 138.869 460.516C141.614 458.867 145.09 459.05 148.2 459.6C150.03 459.6 153.689 461.066 154.97 461.799L255.783 519.707L263.467 524.105L362.816 581.28C363.914 581.83 370.866 586.411 370.866 587.511C373.794 590.259 372.696 594.291 368.122 597.04L359.889 602.171C358.425 603.087 354.034 604.736 352.204 604.92C349.094 605.653 345.618 605.653 342.69 604.736C341.592 604.736 335.189 601.438 334.457 600.888L238.584 545.362L232.18 541.697L142.711 490.02C141.614 489.47 135.027 485.072 135.027 483.972C135.027 482.873 128.806 477.742 130.087 477.009L128.806 475.543C125.696 473.893 126.611 467.113 129.904 465.097Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7619,
    d: "M130.087 466.197C130.819 465.647 137.771 461.432 138.869 461.432C141.797 460.333 145.09 459.966 148.2 460.333C150.213 460.333 153.506 461.615 154.97 462.532L255.234 520.257L262.918 524.655L361.718 581.463C362.633 582.013 369.769 586.594 369.769 587.511C372.879 590.259 371.964 594.291 367.207 597.04L359.157 602.171C357.51 603.087 353.485 604.736 351.472 604.92C348.362 605.653 344.886 605.469 342.141 604.553C341.226 604.553 334.64 601.071 333.908 600.705L238.767 545.729L232.363 542.064L143.626 490.753C142.711 490.203 135.759 485.805 135.759 484.889C135.759 483.972 128.989 478.841 130.087 478.108L128.806 476.642C125.696 474.626 126.428 468.396 130.087 466.197Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8095,
    d: "M130.087 467.296C130.819 466.93 137.771 462.348 138.503 462.348C141.248 461.066 144.724 460.699 147.651 461.066C149.664 461.066 152.957 462.165 154.421 463.081L254.136 520.623L261.82 525.021L360.255 581.646C360.986 582.013 368.488 586.778 368.488 587.511C371.781 590.259 370.866 594.291 366.292 596.857L358.242 602.171C356.412 603.27 352.753 604.553 350.558 604.736C347.447 605.286 344.154 605.103 341.409 604.003C340.678 604.003 333.908 600.338 333.359 599.972L238.95 545.362L232.729 541.697L144.724 490.753C143.992 490.386 136.857 485.805 136.857 485.072C136.857 484.339 129.538 479.025 130.27 478.658L128.806 477.375C125.696 475.359 126.428 469.495 130.087 467.296Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8571,
    d: "M130.27 468.396C130.819 468.029 137.954 463.448 138.503 463.448C141.248 462.165 144.541 461.615 147.651 461.799C149.847 461.799 152.774 462.715 154.421 463.631L253.77 520.806L261.272 525.204L359.157 581.646C359.706 582.013 367.573 586.778 367.573 587.327C371.049 589.893 370.318 593.924 365.561 596.673L357.693 601.988C355.864 603.087 352.387 604.37 350.192 604.553C347.081 605.103 343.788 604.736 341.226 603.637C340.678 603.637 333.725 599.789 333.176 599.605L239.499 545.362L233.278 541.697L145.822 491.119C145.273 490.753 137.771 486.171 137.771 485.622C137.771 485.072 129.904 479.758 130.453 479.391L128.989 478.108C125.513 476.276 126.245 470.778 130.27 468.396Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M130.27 469.495C130.636 469.312 137.954 464.364 138.32 464.364C141.065 463.081 144.358 462.348 147.468 462.532C149.847 462.532 152.591 463.448 154.238 464.364L253.038 521.356L260.54 525.754L357.876 581.83C358.242 582.013 366.475 586.961 366.475 587.327C370.135 589.893 369.403 593.924 364.829 596.673L356.961 601.988C354.949 603.087 351.838 604.187 349.46 604.37C346.349 604.736 343.056 604.37 340.678 603.27C340.312 603.27 332.993 599.239 332.81 599.055L239.865 545.362L233.644 541.697L146.919 491.669C146.554 491.486 138.686 486.721 138.686 486.355C138.686 485.988 130.087 480.491 130.636 480.307L128.989 479.208C125.513 477.009 126.062 471.878 130.27 469.495Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9524,
    d: "M130.453 470.595C130.636 470.412 138.137 465.464 138.32 465.464C140.882 463.998 144.358 463.265 147.468 463.448C149.847 463.448 152.591 464.181 154.238 465.097L252.672 521.906L260.174 526.304L357.144 582.196C357.327 582.379 365.926 587.327 365.926 587.511C369.769 589.893 369.22 594.108 364.463 596.673L356.778 601.988C354.766 603.087 351.838 604.003 349.277 604.187C346.166 604.553 343.056 604.003 340.677 602.904C340.495 602.904 332.993 598.689 332.993 598.506L240.597 545.179L234.376 541.697L148.2 491.852C148.017 491.669 139.967 486.904 139.967 486.721C139.967 486.538 130.819 481.04 131.002 480.857L129.355 479.758C125.33 477.742 125.879 473.16 130.453 470.595Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.946 602.354L234.559 541.514L129.172 480.674C125.147 478.291 125.696 474.26 130.27 471.511L137.954 466.197C142.711 463.448 149.664 463.265 153.872 465.464L259.259 526.304L364.646 587.144C368.671 589.526 368.122 593.558 363.548 596.307L355.864 601.621C351.106 604.37 344.154 604.736 339.946 602.354Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.047619,
    d: "M61.2927 488.92C64.586 487.088 68.9771 485.805 73.1853 485.805C76.8446 485.622 80.3209 486.538 83.0653 488.004C83.2483 488.004 89.652 491.669 89.652 491.669L197.051 553.242L205.285 558.007L311.037 618.664C314.514 620.679 316.892 624.161 316.892 627.643C317.075 631.675 314.697 635.34 310.306 637.905L300.609 642.853C300.426 642.853 292.558 646.885 292.375 646.885C288.899 648.717 284.691 649.817 280.483 649.817C276.823 649.817 273.164 648.9 270.603 647.251L164.85 585.678L157.897 581.646L59.0971 524.105C55.6208 522.089 53.2423 518.791 53.2423 515.125C53.2423 511.277 55.2549 507.429 59.2801 505.047L59.4631 502.664C59.4631 502.298 61.1097 488.92 61.2927 488.92Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0952381,
    d: "M61.2927 489.836C64.4031 488.004 68.9771 486.721 73.0023 486.538C76.6616 486.355 80.1379 487.088 82.8823 488.554C83.0653 488.554 89.469 492.035 89.469 492.219L196.32 553.425L204.37 558.007L309.757 618.297C313.05 620.13 315.612 623.611 315.795 627.093C315.977 630.942 313.782 634.79 309.391 637.355L299.877 642.303C299.694 642.487 292.009 646.335 291.643 646.335C288.167 648.167 284.142 649.084 279.934 648.9C276.457 648.9 272.615 647.801 270.237 646.335L165.216 585.128L158.263 581.097L60.3779 524.105C57.0845 522.272 54.3401 518.79 54.3401 515.309C54.3401 511.644 55.6208 507.612 59.646 505.413L59.829 503.031C59.4631 503.031 60.9268 490.203 61.2927 489.836Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M61.4757 490.936C64.4031 489.287 69.1601 487.821 73.0024 487.454C76.6616 487.088 80.1379 487.821 82.8824 489.287C83.2483 489.287 89.2861 492.585 89.652 492.768L196.137 553.792L204.187 558.373L309.025 618.48C312.135 620.313 314.88 623.795 315.246 627.093C315.612 630.942 313.599 634.79 309.208 637.355L299.877 642.303C299.511 642.487 292.192 646.152 291.826 646.152C288.35 647.801 284.325 648.717 280.3 648.534C277.006 648.534 272.981 647.251 270.603 645.785L166.314 585.128L159.361 581.097L61.8416 524.471C58.7312 522.639 55.8038 519.157 55.8038 516.042C55.8038 512.56 56.5357 508.528 60.3779 506.329V504.13C59.2801 503.764 60.7438 491.302 61.4757 490.936Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M61.4756 492.036C64.2201 490.386 69.1601 488.92 72.8194 488.554C76.2957 488.187 79.772 488.737 82.6994 490.02C83.2483 490.02 89.1031 493.135 89.469 493.502L195.405 554.158L203.455 558.74L307.927 618.664C310.855 620.313 313.965 623.978 314.331 627.093C314.697 630.942 313.05 634.607 308.476 637.172L299.145 642.12C298.779 642.303 291.643 645.968 291.094 645.968C287.801 647.618 283.593 648.351 279.751 648.167C276.64 648.167 272.432 646.701 270.237 645.419L166.497 585.128L159.544 581.097L62.7564 524.838C59.829 523.189 56.5356 519.524 56.5356 516.591C56.5356 513.293 56.7186 509.261 60.1949 507.062L60.0119 504.863C59.2801 504.497 60.5608 492.585 61.4756 492.036Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M61.6586 493.135C64.2201 491.669 69.3431 490.02 72.6364 489.47C76.1127 488.92 79.589 489.653 82.3334 490.753C82.8823 490.753 88.5542 493.868 89.1031 494.051L194.49 554.525L202.54 559.106L306.463 618.664C309.208 620.313 312.501 623.978 312.867 626.91C313.416 630.575 311.769 634.423 307.378 636.989L298.23 642.12C297.681 642.487 290.729 645.785 290.18 645.785C286.886 647.434 282.861 647.984 279.019 647.801C276.091 647.801 271.7 646.152 269.688 644.869L166.679 584.945L159.91 580.913L63.8542 525.021C61.1097 523.372 57.4505 519.707 57.4505 516.958C57.4505 513.843 57.0845 509.628 60.3779 507.795L60.1949 505.596C59.0971 505.23 60.5608 493.868 61.6586 493.135Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M61.6587 494.235C64.0372 492.769 69.3431 491.119 72.4535 490.569C75.9298 490.02 79.4061 490.569 82.1506 491.669C82.8824 491.669 88.3713 494.601 88.9202 494.784L193.941 555.075L201.991 559.656L305.549 619.03C308.11 620.496 311.769 624.344 312.135 627.093C312.684 630.758 311.403 634.607 306.829 637.172L297.681 642.303C297.132 642.67 290.363 645.968 289.631 645.968C286.338 647.434 282.312 648.167 278.653 647.801C275.909 647.801 271.335 645.968 269.322 644.869L167.046 585.495L160.276 581.463L64.7691 525.937C62.2076 524.471 58.3654 520.623 58.3654 518.057C58.3654 515.125 57.4505 510.911 60.5609 509.078L60.195 507.062C59.0972 505.963 60.378 494.968 61.6587 494.235Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M61.8417 495.334C64.2202 494.051 69.5261 492.219 72.4535 491.486C75.7469 490.753 79.2232 491.302 82.1506 492.402C83.0654 492.402 88.1884 495.151 88.9202 495.517L193.392 555.441L201.26 560.023L304.268 619.213C306.646 620.679 311.038 624.528 311.038 626.91C312.318 630.392 310.489 634.24 306.098 636.806L297.132 641.937C296.4 642.303 289.997 645.419 289.082 645.419C285.789 646.885 281.946 647.434 278.287 646.885C275.726 646.885 270.969 644.869 269.139 643.769L167.594 584.762L160.825 580.913L66.0498 525.937C63.6713 524.471 59.4632 520.623 59.4632 518.241C59.4632 515.492 57.9995 511.094 60.7439 509.445L60.378 507.429C58.9143 506.696 60.195 496.25 61.8417 495.334Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M61.8416 496.434C64.0371 495.151 69.709 493.135 72.2705 492.585C75.5638 491.669 79.0401 492.219 81.9675 493.135C82.8823 493.135 88.0053 495.701 88.7372 496.067L192.843 555.808L200.711 560.389L303.353 619.213C305.549 620.496 310.306 624.528 310.306 626.727C311.769 630.209 310.123 634.057 305.549 636.622L296.583 641.754C295.669 642.303 289.631 645.052 288.716 645.235C285.423 646.518 281.58 647.068 278.104 646.518C275.726 646.518 270.786 644.319 268.956 643.403L168.143 584.762L161.374 580.913L67.3305 526.304C65.1349 525.021 60.5608 521.173 60.5608 518.791C60.5608 516.225 58.3653 511.827 61.1097 510.178L60.5608 508.345C58.9142 507.429 60.0119 497.35 61.8416 496.434Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M62.0246 497.35C64.0372 496.25 69.892 494.051 72.2705 493.318C75.5639 492.402 78.8572 492.768 81.7846 493.685C82.8824 493.685 87.6394 496.067 88.5543 496.617L192.111 556.174L199.979 560.756L302.072 619.397C304.085 620.679 309.208 624.711 309.208 626.727C311.038 630.025 309.208 633.874 304.817 636.622L296.035 641.754C295.12 642.303 289.265 645.052 288.167 645.052C284.874 646.335 281.032 646.701 277.738 646.152C275.543 646.152 270.237 643.769 268.773 642.853L168.326 584.762L161.74 580.913L68.2453 526.67C66.2327 525.388 61.2927 521.539 61.2927 519.34C61.2927 516.958 58.5483 512.56 61.1098 511.094L60.5609 509.261C58.7312 508.162 60.012 498.633 62.0246 497.35Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M62.0246 498.449C63.8542 497.35 69.892 494.968 72.0876 494.235C75.198 493.135 78.6742 493.685 81.6017 494.418C82.8824 494.418 87.4565 496.617 88.3713 497.167L191.38 556.357L199.247 560.939L300.792 619.397C302.621 620.496 307.927 624.711 307.927 626.544C309.94 629.842 308.293 633.69 303.719 636.256L294.937 641.387C293.839 641.937 288.35 644.502 287.069 644.686C283.776 645.785 280.117 646.152 276.823 645.602C274.811 645.602 269.322 643.036 268.041 642.303L168.692 584.578L162.105 580.73L69.3431 526.854C67.5135 525.754 62.3905 521.723 62.3905 519.707C62.3905 517.508 59.0972 512.926 61.4757 511.644L60.7439 509.811C58.7313 508.895 59.829 499.732 62.0246 498.449Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5238,
    d: "M62.0245 499.549C63.6712 498.633 69.8919 496.067 71.7216 495.334C74.832 494.234 78.3083 494.601 81.2357 495.334C82.5164 495.334 87.0905 497.35 88.0053 497.9L190.648 556.907L198.515 561.305L299.694 619.397C301.34 620.313 307.012 624.711 307.012 626.36C309.208 629.476 307.744 633.507 303.17 636.073L294.571 641.387C293.473 642.12 288.167 644.502 286.703 644.502C283.41 645.602 279.751 645.785 276.64 645.235C274.811 645.235 269.139 642.487 267.858 641.754L169.058 584.578L162.471 580.73L70.4408 527.403C68.7942 526.487 63.3053 522.272 63.3053 520.44C63.3053 518.424 59.463 513.843 61.4756 512.56L60.7438 510.911C58.5482 509.628 59.646 501.015 62.0245 499.549Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5714,
    d: "M62.2075 500.648C63.6712 499.732 70.075 496.983 71.7216 496.25C74.649 494.968 78.1253 495.334 81.2357 496.067C82.6994 496.067 86.9076 498.083 88.0054 498.633L190.099 557.274L197.783 561.672L298.413 619.58C300.06 620.496 305.915 624.894 305.915 626.36C308.293 629.476 306.829 633.324 302.255 636.073L293.656 641.204C292.375 641.937 287.435 644.136 285.789 644.319C282.495 645.235 279.019 645.419 275.909 644.686C274.262 644.686 268.407 641.754 267.309 641.204L169.241 584.395L162.654 580.547L71.1727 527.587C69.5261 526.67 63.8542 522.456 63.8542 520.99C63.8542 519.34 59.4631 514.392 61.2927 513.293L60.3779 511.644C58.5483 510.361 59.4631 502.298 62.2075 500.648Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.619,
    d: "M62.2075 501.748C63.4882 501.015 70.0749 498.083 71.5386 497.35C74.466 496.067 77.9423 496.25 80.8698 496.8C82.5164 496.8 86.5416 498.633 87.6394 499.182L189.367 557.64L197.051 562.038L297.315 619.763C298.779 620.496 305 625.077 305 626.36C307.561 629.292 306.28 633.324 301.706 635.889L293.29 641.021C292.009 641.754 287.069 643.769 285.606 643.953C282.312 644.869 278.836 645.052 275.909 644.136C274.445 644.136 268.407 641.021 267.309 640.471L169.973 584.029L163.569 580.364L72.8194 527.77C71.3557 527.037 65.5008 522.639 65.5008 521.356C65.5008 519.89 60.3779 514.942 62.2075 514.026L61.1097 512.377C58.3653 511.094 59.4631 503.397 62.2075 501.748Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M62.3905 502.847C63.4882 502.114 70.2579 498.999 71.5386 498.266C74.2831 496.8 77.9423 496.983 80.8698 497.533C82.5164 497.533 86.3587 499.182 87.6394 499.915L188.818 558.19L196.502 562.588L296.217 619.946C297.498 620.679 304.085 625.078 304.085 626.36C306.829 629.292 305.549 633.324 300.974 635.889L292.558 641.021C291.094 641.937 286.52 643.769 284.874 643.953C281.58 644.686 278.104 644.869 275.36 643.953C274.079 643.953 267.858 640.654 266.943 640.288L170.339 584.395L163.935 580.73L73.9172 528.503C72.6364 527.77 66.4157 523.372 66.4157 522.272C66.4157 520.99 60.7438 515.858 62.2075 515.125L61.1097 513.659C58.3653 512.01 59.2801 504.68 62.3905 502.847Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M62.3905 503.947C63.3053 503.397 70.2579 499.915 71.3557 499.366C74.1002 497.716 77.5765 497.9 80.6868 498.449C82.5165 498.449 86.1757 499.915 87.4565 500.648L188.269 558.556L195.954 562.955L295.303 620.13C296.4 620.679 303.353 625.261 303.353 626.36C306.28 629.109 305.183 633.141 300.609 635.889L292.375 641.021C290.912 641.937 286.52 643.586 284.691 643.769C281.58 644.502 278.104 644.502 275.177 643.586C274.079 643.586 267.675 640.288 266.943 639.738L171.071 584.212L164.667 580.547L75.015 528.869C73.9172 528.32 67.3305 523.922 67.3305 522.822C67.3305 521.723 61.1098 516.591 62.3905 515.858L61.1098 514.392C58.1824 512.743 59.0972 505.78 62.3905 503.947Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7619,
    d: "M62.5735 505.046C63.3053 504.497 70.2579 500.282 71.3557 500.282C74.2831 499.182 77.5764 498.816 80.6868 499.182C82.6994 499.182 85.9927 500.465 87.4564 501.381L187.72 559.106L195.405 563.504L294.205 620.313C295.12 620.863 302.255 625.444 302.255 626.36C305.366 629.109 304.451 633.141 299.694 635.889L291.643 641.02C289.997 641.937 285.972 643.586 283.959 643.769C280.849 644.502 277.372 644.319 274.628 643.403C273.713 643.403 267.126 639.921 266.394 639.554L171.254 584.578L164.85 580.913L76.1127 529.602C75.1979 529.053 68.2453 524.655 68.2453 523.738C68.2453 522.822 61.4757 517.691 62.5735 516.958L61.2927 515.492C58.1823 513.476 58.9142 507.062 62.5735 505.046Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8095,
    d: "M62.5735 505.963C63.3053 505.596 70.2579 501.015 70.9898 501.015C73.7342 499.732 77.2105 499.366 80.1379 499.732C82.1505 499.732 85.4439 500.832 86.9076 501.748L186.623 559.29L194.307 563.688L292.741 620.313C293.473 620.679 300.975 625.444 300.975 626.177C304.268 628.926 303.353 632.957 298.779 635.523L290.729 640.837C288.899 641.937 285.24 643.22 283.044 643.403C279.934 643.953 276.64 643.769 273.896 642.67C273.164 642.67 266.394 639.005 265.846 638.638L171.437 584.029L165.216 580.364L77.2105 529.602C76.4787 529.236 69.3431 524.655 69.3431 523.922C69.3431 523.189 62.0246 517.874 62.7564 517.508L61.2927 516.225C57.9994 514.209 58.7312 508.162 62.5735 505.963Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8571,
    d: "M62.7565 507.062C63.3054 506.696 70.4409 502.114 70.9898 502.114C73.7343 500.832 77.0276 500.282 80.138 500.465C82.3335 500.465 85.2609 501.381 86.9076 502.298L186.257 559.473L193.758 563.871L291.643 620.313C292.192 620.679 300.06 625.444 300.06 625.994C303.536 628.559 302.804 632.591 298.047 635.34L290.18 640.654C288.35 641.754 284.874 643.036 282.678 643.22C279.568 643.769 276.275 643.403 273.713 642.303C273.164 642.303 266.212 638.455 265.663 638.272L171.986 584.029L165.765 580.364L78.3083 529.786C77.7594 529.419 70.258 524.838 70.258 524.288C70.258 523.738 62.3905 518.424 62.9394 518.058L61.4757 516.775C57.9994 514.942 58.7313 509.445 62.7565 507.062Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M62.7564 508.162C63.1223 507.979 70.4409 503.031 70.8068 503.031C73.5512 501.748 76.8446 501.015 79.955 501.198C82.3335 501.198 85.0779 502.114 86.7246 503.031L185.525 560.023L193.026 564.421L290.363 620.496C290.729 620.679 298.962 625.627 298.962 625.994C302.621 628.559 301.889 632.591 297.315 635.34L289.448 640.654C287.435 641.754 284.325 642.853 281.946 643.036C278.836 643.403 275.543 643.036 273.164 641.937C272.798 641.937 265.48 637.905 265.297 637.722L172.351 584.029L166.131 580.364L79.4061 530.335C79.0401 530.152 71.1727 525.388 71.1727 525.021C71.1727 524.655 62.5734 519.157 63.1223 518.974L61.4757 517.874C57.9994 515.675 58.5483 510.544 62.7564 508.162Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9524,
    d: "M62.9394 509.261C63.1224 509.078 70.6239 504.13 70.8068 504.13C73.3683 502.664 76.8446 501.931 79.955 502.114C82.3335 502.114 85.078 502.847 86.7246 503.764L185.159 560.572L192.66 564.97L289.631 620.863C289.814 621.046 298.413 625.994 298.413 626.177C302.255 628.559 301.706 632.774 296.949 635.34L289.265 640.654C287.252 641.754 284.325 642.67 281.763 642.853C278.653 643.22 275.543 642.67 273.164 641.57C272.981 641.57 265.48 637.355 265.48 637.172L173.083 583.845L166.863 580.364L80.5039 530.702C80.3209 530.519 72.2705 525.754 72.2705 525.571C72.2705 525.388 63.1224 519.89 63.3054 519.707L61.6587 518.607C57.8165 516.408 58.3654 511.827 62.9394 509.261Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.432 641.021L167.046 580.18L61.6587 519.34C57.6335 516.958 58.1824 512.926 62.7565 510.178L70.4409 504.863C75.198 502.114 82.1506 501.931 86.3587 504.13L191.746 564.97L297.132 625.811C301.158 628.193 300.609 632.224 296.035 634.973L288.35 640.288C283.593 643.036 276.64 643.403 272.432 641.021Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.096 34.0851C175.096 36.1009 174.913 314.463 174.913 341.218C174.913 355.878 174.913 380.434 174.913 380.617C174.913 390.33 168.692 402.058 160.459 408.289C174.547 416.352 359.706 521.906 383.674 535.833H404.715C404.715 545.179 404.715 552.876 404.715 552.876C404.715 559.656 409.289 563.871 413.863 564.787C414.229 564.787 414.595 564.97 414.961 564.97C415.144 564.97 415.509 564.97 415.692 564.97C415.875 564.97 416.058 564.97 416.241 564.97C418.254 564.787 420.632 564.054 423.011 562.588C425.572 561.122 427.951 558.923 430.147 556.541C432.891 553.975 434.904 551.043 436.184 547.378C438.563 542.613 439.844 537.666 439.844 533.084C439.844 533.084 439.844 531.252 439.844 526.67C439.844 525.571 439.844 186.369 439.844 185.269L175.096 34.0851Z",
    fill: "url(#paint31_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.096 50.9445L440.392 202.312C440.392 191.866 440.392 179.039 440.392 183.986L175.096 32.6191C175.096 29.3205 174.913 203.778 174.913 230.533C174.913 237.496 174.913 246.842 174.913 254.539C175.096 212.024 175.096 61.9397 175.096 50.9445Z",
    fill: "url(#paint32_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.939 435.593C367.939 435.777 369.403 436.876 371.781 438.526C371.781 438.342 371.781 437.976 371.781 437.792C369.586 436.326 367.939 435.593 367.939 435.593Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.392 79.3487V83.9301L299.694 144.587V140.006L193.392 79.3487Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.382 138.906L193.392 98.0406V102.622L264.382 143.487V138.906Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.451 119.115L193.392 88.5114V93.0927L246.451 123.696V119.115Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.026 121.68V126.262L354.034 184.903V180.321L251.026 121.68Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.956 141.655V146.236L321.1 176.107V171.525L268.956 141.655Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.425 187.468L421.913 223.569V218.988L358.425 182.887V187.468Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.491 178.672L391.724 216.056V211.474L325.491 174.091V178.672Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.763 282.394V277.812L299.145 254.539V259.12L339.763 282.394Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.211 207.443V212.024L346.349 257.654V253.073L266.211 207.443Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.854 251.973L266.211 226.135V230.716L310.854 256.555V251.973Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.019 224.302L266.211 216.606V221.187L279.019 228.884V224.302Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.593 226.868V231.449L400.506 297.97V293.206L283.593 226.868Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.428 254.539V259.12L352.936 280.928V276.346L315.428 254.539Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.51 283.493L421.913 319.594V315.013L357.51 278.912V283.493Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.571 251.973L266.211 235.664V240.245L294.571 256.555V251.973Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.154 284.959L404.715 319.227V314.646L344.154 280.378V284.959Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.763 236.58V231.999L299.145 208.909V213.49L339.763 236.58Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.211 161.813V166.394L346.349 211.841V207.26L266.211 161.813Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.854 206.343L266.211 180.505V185.086L310.854 210.925V206.343Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.019 178.489L266.211 170.975V175.557L279.019 183.07V178.489Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.593 181.238V185.819L400.506 252.157V247.575L283.593 181.238Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.428 208.909V213.49L352.936 235.297V230.716L315.428 208.909Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.51 237.863L421.913 273.781V269.199L357.51 233.282V237.863Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.571 206.343L266.211 189.851V194.432L294.571 210.925V206.343Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.154 239.329L404.715 273.597V269.016L344.154 234.748V239.329Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.811 294.305V289.724L239.499 269.932V274.514L274.811 294.305Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.392 214.956V219.538L286.703 272.864V268.283L193.392 214.956Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.391 267.184L193.392 233.648V238.229L251.391 271.765V267.184Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.461 247.209L193.392 224.119V228.7L233.461 251.79V247.209Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.852 249.958V254.539L340.86 313.18V308.599L237.852 249.958Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.783 269.749V274.33L307.927 304.201V299.619L255.783 269.749Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.435 315.746L378.734 334.804V330.223L345.435 311.164V315.746Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.501 306.95L408.923 361.376V356.794L312.501 302.368V306.95Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.108 267.184L193.392 243.177V247.759L235.108 271.765V267.184Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.202 297.054L315.246 317.578V312.997L279.202 292.473V297.054Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.801 347.449V342.867L252.672 322.893V327.474L287.801 347.449Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.392 260.586V265.168L299.694 326.008V321.427L193.392 260.586Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.382 320.327L193.392 279.278V283.86L264.382 324.908V320.327Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.546 292.656L193.392 269.749V274.33L232.546 297.237V292.656Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.12 295.221V299.803L354.034 366.14V361.559L237.12 295.221Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.956 322.893V327.474L306.463 349.281V344.7L268.956 322.893Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.425 368.889L421.913 404.807V400.225L358.425 364.125V368.889Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.037 351.847L364.28 381.717V377.136L311.037 347.265V351.847Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.098 320.327L193.392 288.807V293.389L248.098 324.908V320.327Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.192 350.014L328.236 370.538V365.957L292.192 345.433V350.014Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.51 446.955L421.913 483.056V478.475L357.51 442.374V446.955Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.51 405.54L421.913 441.458V436.876L357.51 400.775V405.54Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0909091,
    d: "M174.913 228.7C161.557 221.004 150.762 227.234 150.762 242.444V376.952C150.762 392.162 161.557 423.315 174.913 431.012L408.008 562.405C421.364 570.101 415.875 554.525 415.875 539.132V404.624C415.875 389.414 400.324 358.993 386.967 351.297L174.913 228.7Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1818,
    d: "M174.547 229.067C161.191 221.37 150.579 227.601 150.579 242.811V363.758C150.579 378.968 161.374 422.582 174.547 430.279L405.263 560.572C418.62 568.269 414.778 553.609 414.778 538.399V417.451C414.778 402.241 399.592 359.36 386.418 351.663L174.547 229.067Z",
    fill: "#A0A5D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2727,
    d: "M174.364 229.617C161.191 221.92 150.396 228.151 150.396 243.361V350.747C150.396 365.957 161.191 422.033 174.364 429.729L402.519 558.923C415.692 566.62 413.68 552.876 413.68 537.666V430.279C413.68 415.069 399.043 359.543 385.869 351.847L174.364 229.617Z",
    fill: "#989CD3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3636,
    d: "M173.998 229.983C160.825 222.286 150.03 228.517 150.03 243.727V337.736C150.03 352.946 160.825 421.483 173.998 429.18L399.775 557.09C412.948 564.787 412.399 551.959 412.399 536.749V442.74C412.399 427.53 398.311 359.543 384.955 351.847L173.998 229.983Z",
    fill: "#9094CD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4545,
    d: "M173.632 230.35C160.459 222.653 149.664 228.884 149.664 244.094V324.542C149.664 339.752 160.459 420.75 173.632 428.447L396.847 555.441C410.021 563.138 411.118 551.226 411.118 536.016V455.568C411.118 440.358 397.579 359.727 384.223 352.03L173.632 230.35Z",
    fill: "#898BC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5455,
    d: "M173.449 230.899C160.276 223.203 149.481 229.433 149.481 244.643V311.531C149.481 326.741 160.276 420.2 173.449 427.897L394.103 553.792C407.276 561.489 410.021 550.493 410.021 535.467V468.579C410.021 453.369 396.847 360.276 383.674 352.58L173.449 230.899Z",
    fill: "#8183C1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6364,
    d: "M173.083 231.266C159.91 223.569 149.115 229.8 149.115 244.827V298.153C149.115 313.363 159.727 419.284 173.083 426.981L391.358 551.776C404.532 559.473 408.74 549.577 408.74 534.367V481.04C408.74 465.83 396.115 360.093 382.942 352.58L173.083 231.266Z",
    fill: "#7A7ABB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7273,
    d: "M172.9 231.632C159.727 223.936 149.115 230.166 149.115 245.193V284.959C149.115 300.169 159.727 418.734 172.9 426.248L388.614 549.944C401.787 557.64 407.642 548.661 407.642 533.451V493.685C407.642 478.475 395.566 360.276 382.393 352.58L172.9 231.632Z",
    fill: "#7272B5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8182,
    d: "M172.534 232.182C159.361 224.485 148.749 230.716 148.749 245.743V271.948C148.749 287.158 159.361 418.184 172.534 425.698L385.869 548.294C399.043 555.991 406.544 547.928 406.544 532.718V506.512C406.544 491.302 394.835 360.46 381.661 352.946L172.534 232.182Z",
    fill: "#6A69AF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9091,
    d: "M172.168 232.549C158.995 225.035 148.383 231.083 148.383 246.109V258.937C148.383 273.964 158.995 417.635 172.168 425.148L382.942 546.645C396.115 554.158 405.081 547.195 405.081 532.168V519.34C405.081 504.313 393.92 360.826 380.746 353.129L172.168 232.549Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.985 232.915C158.812 225.402 148.2 231.449 148.2 246.476V245.743C148.2 260.77 158.812 416.902 171.985 424.415L380.198 544.813C393.371 552.326 403.983 546.279 403.983 531.252V531.985C403.983 516.958 393.371 360.826 380.198 353.313L171.985 232.915Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M406.361 553.059C406.361 552.876 406.361 386.482 406.361 372.738C405.995 370.355 405.812 369.072 405.812 369.072C405.446 358.81 397.945 354.779 388.797 360.093C379.649 365.407 372.147 378.052 371.781 388.681C371.781 388.864 371.781 532.901 371.781 541.697C381.478 547.195 412.033 564.604 412.033 564.604V564.421C408.557 562.771 406.361 558.923 406.361 553.059Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.047619,
    d: "M335.006 324.175C321.649 316.479 130.819 242.444 130.819 257.654V395.094C130.819 410.304 123.683 461.066 137.039 468.762L349.46 591.542C362.816 599.239 396.481 572.667 396.481 557.457V407.556C396.481 392.346 412.033 367.423 398.677 359.727L335.006 324.175Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0952381,
    d: "M325.126 319.594C311.769 311.897 130.087 241.895 130.087 257.105V393.995C130.087 409.205 123.866 458.317 137.222 466.014L349.46 588.61C362.816 596.307 395.383 570.835 395.383 555.441V406.823C395.383 391.613 409.655 367.057 396.298 359.36L325.126 319.594Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M315.246 315.196C301.889 307.499 129.172 241.528 129.172 256.738V393.079C129.172 408.289 123.866 455.935 137.222 463.448L349.277 585.861C362.633 593.558 393.92 569.002 393.92 553.792V406.09C393.92 390.88 406.727 366.69 393.554 358.993L315.246 315.196Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M305.549 310.798C292.192 303.101 128.44 241.162 128.44 256.372V392.162C128.44 407.372 124.049 453.369 137.222 461.066L348.911 583.479C362.267 591.176 392.456 567.719 392.456 552.326V405.906C392.456 390.696 403.983 366.69 390.809 359.177L305.549 310.798Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M295.669 306.4C282.495 298.703 127.525 240.612 127.525 256.005V391.246C127.525 406.456 124.049 450.803 137.222 458.5L348.728 580.73C361.901 588.427 391.175 565.887 391.175 550.677V405.357C391.175 390.147 401.421 366.507 388.248 358.81L295.669 306.4Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M285.788 302.002C272.615 294.305 126.793 240.245 126.793 255.455V390.33C126.793 405.54 124.049 448.238 137.405 455.935L348.728 577.981C361.901 585.678 389.895 564.237 389.895 549.027V404.807C389.895 389.597 398.86 366.324 385.686 358.627L285.788 302.002Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M275.909 297.604C262.735 289.907 125.879 239.879 125.879 255.089V389.23C125.879 404.44 124.049 445.489 137.405 453.186L348.545 575.233C361.718 582.929 388.614 562.405 388.614 547.195V404.257C388.614 389.047 396.298 366.14 383.125 358.444L275.909 297.604Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M266.211 293.022C253.038 285.326 125.147 239.329 125.147 254.539V388.314C125.147 403.524 124.232 442.924 137.588 450.62L348.545 572.484C361.718 580.18 387.516 560.756 387.516 545.546V403.707C387.516 388.497 393.92 365.957 380.563 358.26L266.211 293.022Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M256.331 288.624C243.158 280.928 124.415 238.963 124.415 254.173V387.398C124.415 402.608 124.415 440.358 137.588 448.055L348.362 569.918C361.535 577.615 386.052 559.289 386.052 544.079V403.158C386.052 387.948 391.175 365.774 377.819 358.077L256.331 288.624Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M246.451 284.226C233.278 276.529 123.5 238.596 123.5 253.806V386.482C123.5 401.692 124.415 437.793 137.588 445.489L348.179 567.169C361.352 574.866 384.772 557.457 384.772 542.247V402.791C384.772 387.581 388.431 365.591 375.258 358.077L246.451 284.226Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5238,
    d: "M236.571 279.828C223.398 272.131 122.585 238.229 122.585 253.44V385.565C122.585 400.775 124.415 435.227 137.588 442.924L347.996 564.421C361.169 572.117 383.308 555.808 383.308 540.598V402.241C383.308 387.031 385.686 365.407 372.513 357.894L236.571 279.828Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5714,
    d: "M226.691 275.43C213.518 267.733 121.671 237.863 121.671 252.89V384.466C121.671 399.676 124.415 432.661 137.588 440.175L347.63 561.672C360.803 569.368 381.844 553.975 381.844 538.765V401.508C381.844 386.298 382.942 365.041 369.769 357.344L226.691 275.43Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.619,
    d: "M216.994 271.032C203.821 263.335 121.122 237.496 121.122 252.523V383.549C121.122 398.76 124.598 430.096 137.771 437.609L347.63 558.923C360.803 566.62 380.746 552.326 380.746 537.116V401.142C380.746 385.932 380.563 365.041 367.39 357.344L216.994 271.032Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M207.114 266.451C193.941 258.754 120.207 236.763 120.207 251.973V382.45C120.207 397.66 124.598 427.347 137.771 434.86L347.447 555.991C360.62 563.688 379.283 550.31 379.283 535.283V400.409C379.283 385.199 377.819 364.674 364.646 356.978L207.114 266.451Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M197.234 262.052C184.061 254.356 119.292 236.397 119.292 251.607V381.534C119.292 396.744 124.598 424.781 137.771 432.478L347.264 553.609C360.438 561.305 378.002 549.027 378.002 533.817V400.042C378.002 384.832 375.258 364.491 362.084 356.978L197.234 262.052Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7619,
    d: "M187.354 257.654C174.181 249.958 118.56 236.03 118.56 251.24V380.617C118.56 395.827 124.781 422.216 137.954 429.913L347.264 550.86C360.437 558.557 376.904 547.195 376.904 532.168V399.493C376.904 384.282 372.879 364.308 359.706 356.794L187.354 257.654Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8095,
    d: "M177.657 253.256C164.484 245.56 117.828 235.664 117.828 250.874V379.701C117.828 394.911 124.964 419.65 138.137 427.347L347.264 548.111C360.437 555.808 375.623 545.546 375.623 530.335V398.943C375.623 383.733 370.135 364.125 357.144 356.611L177.657 253.256Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8571,
    d: "M167.777 248.858C154.604 241.345 116.913 235.297 116.913 250.507V378.785C116.913 393.812 124.964 417.085 137.954 424.781L346.898 545.546C360.072 553.059 374.16 544.079 374.16 528.869V398.576C374.16 383.549 367.39 364.125 354.217 356.428L167.777 248.858Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M157.897 244.46C144.724 236.947 116.182 234.931 116.182 249.958V377.869C116.182 392.895 124.964 414.519 138.137 422.216L346.898 542.797C360.072 550.31 373.062 542.247 373.062 527.22V398.21C373.062 383.183 365.012 364.125 351.838 356.428L157.897 244.46Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9524,
    d: "M148.017 239.879C134.844 232.365 115.267 234.381 115.267 249.408V376.769C115.267 391.796 124.964 411.77 138.137 419.467L346.532 539.865C359.706 547.378 371.415 540.414 371.415 525.204V397.293C371.415 382.267 362.084 363.575 348.911 355.878L148.017 239.879Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.32 235.481C125.147 227.967 114.535 234.015 114.535 249.041V375.853C114.535 390.88 125.147 409.388 138.32 416.902L346.532 537.299C359.706 544.812 370.317 538.765 370.317 523.738V396.927C370.317 381.9 359.706 363.392 346.532 355.878L138.32 235.481Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.222 208.726C134.112 205.61 129.172 205.427 123.5 208.726C114.352 214.04 106.851 226.685 106.485 237.313C106.485 237.313 106.485 242.261 106.485 243.544C106.485 245.56 106.302 420.567 106.302 420.75C106.302 430.462 100.081 442.191 91.8475 448.421C105.936 456.484 291.094 562.038 315.063 575.966C315.063 575.966 318.905 579.631 320.735 579.997C320.917 579.997 331.529 585.312 337.75 588.244C337.75 591.176 337.75 593.008 337.75 593.008C337.75 599.789 340.677 604.003 345.252 604.92C345.617 604.92 345.983 605.103 346.349 605.103C346.532 605.103 346.898 605.103 347.081 605.103C347.264 605.103 347.447 605.103 347.63 605.103C349.643 604.92 352.021 604.187 354.4 602.721C356.961 601.255 359.34 599.056 361.535 596.673C364.28 594.108 366.292 591.176 367.573 587.511C369.952 582.746 371.232 577.798 371.232 573.217C371.232 573.217 371.415 571.384 371.415 569.368C371.415 568.452 371.415 435.044 371.415 391.613V391.429C371.415 389.78 371.415 388.681 371.415 388.681C371.781 378.052 379.283 365.407 388.431 360.093C392.09 357.894 395.566 357.344 398.494 358.077L137.222 208.726Z",
    fill: "url(#paint33_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.36 328.207V323.626L182.048 303.651V308.232L217.36 328.207Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.951 241.345V245.926L229.253 306.583V302.002L122.951 241.345Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.941 300.902L122.951 260.037V264.618L193.941 305.483V300.902Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.011 280.928L122.951 250.507V255.089L176.011 285.692V280.928Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.402 283.676V288.258L283.41 346.899V342.317L180.402 283.676Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.515 303.468V308.232L250.477 338.103V333.521L198.515 303.468Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.984 349.464L351.472 385.565V380.984L287.984 344.883V349.464Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.051 340.668L321.283 378.052V373.471L255.051 336.087V340.668Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.657 301.085L122.951 269.383V273.964L177.657 305.667V301.085Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.751 330.772L257.795 351.297V346.716L221.751 326.191V330.772Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.36 445.123V440.541L182.048 420.567V425.148L217.36 445.123Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.942 365.591V370.172L229.253 423.499V418.917L135.942 365.591Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.941 417.818L135.942 384.466V389.047L193.941 422.399V417.818Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.011 398.027L135.942 374.937V379.518L176.011 402.608V398.027Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.402 400.592V405.173L283.41 463.814V459.233L180.402 400.592Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.515 420.567V425.148L250.477 455.018V450.437L198.515 420.567Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.984 466.38L321.283 485.438V480.857L287.984 461.799V466.38Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.051 457.584L351.472 512.01V507.429L255.051 453.003V457.584Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.657 418.001L135.942 393.812V398.393L177.657 422.582V418.001Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.751 447.688L257.795 468.213V463.631L221.751 443.107V447.688Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.36 486.355V481.773L182.048 461.799V466.38L217.36 486.355Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.951 399.492V404.074L229.253 464.731V460.149L122.951 399.492Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.941 459.05L122.951 418.184V422.766L193.941 463.631V459.05Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.105 431.379L122.951 408.655V413.237L162.105 435.96V431.379Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.679 433.944V438.525L283.41 505.046V500.465L166.679 433.944Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.515 461.799V466.38L236.023 488.004V483.423L198.515 461.799Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.984 507.612L351.472 543.713V539.132L287.984 503.031V507.612Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.597 490.753L293.839 520.623V516.042L240.597 486.171V490.753Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.657 459.233L122.951 427.714V432.295L177.657 463.814V459.233Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.751 488.92L257.795 509.445V504.863L221.751 484.339V488.92Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.051 376.586L351.472 431.012V426.431L255.051 372.005V376.586Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.051 394.361L351.472 448.788V444.206L255.051 389.78V394.361Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.051 412.137L351.472 466.563V461.982L255.051 407.556V412.137Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.208 372.371C251.208 375.303 249.196 376.403 246.634 374.937C244.073 373.471 242.06 369.805 242.06 366.873C242.06 363.941 244.073 362.842 246.634 364.308C249.013 365.957 251.208 369.439 251.208 372.371Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.208 390.513C251.208 393.445 249.196 394.545 246.634 393.079C244.073 391.613 242.06 387.948 242.06 385.016C242.06 382.083 244.073 380.984 246.634 382.45C249.013 383.916 251.208 387.581 251.208 390.513Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.208 407.922C251.208 410.854 249.196 411.954 246.634 410.488C244.073 409.022 242.06 405.357 242.06 402.425C242.06 399.493 244.073 398.393 246.634 399.859C249.013 401.508 251.208 404.99 251.208 407.922Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0909091,
    d: "M102.276 402.791C88.9201 395.094 78.1252 401.325 78.1252 416.535V425.881C78.1252 441.091 88.9201 459.783 102.276 467.48L335.554 598.872C348.911 606.569 343.422 590.992 343.422 575.599V566.253C343.422 551.043 327.87 533.084 314.514 525.388L102.276 402.791Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1818,
    d: "M102.459 403.524C89.1031 395.827 78.4912 402.058 78.4912 417.268V425.698C78.4912 440.908 89.286 459.6 102.459 467.296L333.176 597.406C346.532 605.103 342.69 590.443 342.69 575.233V566.803C342.69 551.593 327.504 533.634 314.331 525.937L102.459 403.524Z",
    fill: "#A0A5D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2727,
    d: "M102.642 404.257C89.469 396.56 78.6742 402.791 78.6742 418.001V425.331C78.6742 440.541 89.469 459.05 102.642 466.747L330.798 595.94C343.971 603.637 341.958 589.893 341.958 574.683V567.353C341.958 552.143 327.321 534.184 314.148 526.487L102.642 404.257Z",
    fill: "#989CD3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3636,
    d: "M102.642 405.173C89.469 397.477 78.6742 403.707 78.6742 418.917V425.331C78.6742 440.541 89.469 459.05 102.642 466.747L328.419 594.841C341.592 602.537 341.043 589.71 341.043 574.5V568.086C341.043 552.876 326.955 534.917 313.599 527.22L102.642 405.173Z",
    fill: "#9094CD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4545,
    d: "M102.825 405.906C89.6519 398.21 78.8571 404.44 78.8571 419.65V424.965C78.8571 440.175 89.6519 458.683 102.825 466.38L326.04 593.375C339.214 601.071 340.311 589.16 340.311 573.95V568.635C340.311 553.425 326.772 535.467 313.416 527.77L102.825 405.906Z",
    fill: "#898BC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5455,
    d: "M102.825 406.639C89.6519 398.943 78.8571 405.173 78.8571 420.383V424.598C78.8571 439.808 89.6519 458.317 102.825 465.83L323.479 591.725C336.652 599.422 339.397 588.427 339.397 573.4V569.185C339.397 553.975 326.223 535.833 313.05 528.32L102.825 406.639Z",
    fill: "#8183C1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6364,
    d: "M103.008 407.372C89.8349 399.676 79.04 405.906 79.04 420.933V424.232C79.04 439.442 89.6519 457.95 103.008 465.464L321.283 590.259C334.457 597.956 338.665 588.06 338.665 572.85V569.552C338.665 554.342 326.04 536.2 312.867 528.686L103.008 407.372Z",
    fill: "#7A7ABB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7273,
    d: "M103.191 408.105C90.0179 400.409 79.406 406.639 79.406 421.666V423.865C79.406 439.075 90.0179 457.401 103.191 465.097L318.905 588.793C332.078 596.49 337.933 587.511 337.933 572.301V570.102C337.933 554.892 325.857 536.749 312.684 529.053L103.191 408.105Z",
    fill: "#7272B5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8182,
    d: "M103.191 408.838C90.0179 401.142 79.406 407.372 79.406 422.399V423.682C79.406 438.892 90.0179 457.217 103.191 464.914L316.526 587.511C329.7 595.207 337.201 587.144 337.201 571.934V570.651C337.201 555.441 325.492 537.299 312.318 529.602L103.191 408.838Z",
    fill: "#6A69AF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9091,
    d: "M103.374 409.571C90.2009 402.058 79.589 408.105 79.589 423.132V423.316C79.589 438.342 90.2009 456.851 103.374 464.364L314.148 585.861C327.321 593.375 336.286 586.411 336.286 571.384V571.201C336.286 556.174 325.126 537.849 311.952 530.152L103.374 409.571Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.374 410.488C90.2009 402.974 79.589 409.022 79.589 424.049V423.315C79.589 438.342 90.2009 456.851 103.374 464.364L311.769 584.579C324.943 592.092 335.554 586.045 335.554 571.018V571.751C335.554 556.724 324.943 538.215 311.769 530.702L103.374 410.488Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M337.933 592.825C337.933 592.642 337.933 564.054 337.933 550.127C337.567 547.745 337.384 546.462 337.384 546.462C337.018 536.2 329.517 532.168 320.369 537.482C311.22 542.797 303.719 555.441 303.353 566.07C303.353 566.253 303.353 572.667 303.353 581.463C313.05 586.961 343.605 604.37 343.605 604.37V604.187C340.129 602.537 337.933 598.689 337.933 592.825Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.047619,
    d: "M266.577 501.565C253.221 493.868 62.3906 419.834 62.3906 435.044V433.761C62.3906 448.971 55.255 499.732 68.6113 507.429L281.032 630.209C294.388 637.905 328.053 611.334 328.053 596.123V584.945C328.053 569.735 343.605 544.813 330.249 537.116L266.577 501.565Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0952381,
    d: "M256.697 496.983C243.341 489.287 61.4757 419.284 61.4757 434.677V432.845C61.4757 448.055 55.2549 497.167 68.6112 504.863L280.849 627.46C294.205 635.156 326.772 609.684 326.772 594.291V584.212C326.772 569.002 341.043 544.446 327.687 536.749L256.697 496.983Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M246.817 492.585C233.461 484.889 60.7438 418.917 60.7438 434.127V431.745C60.7438 446.955 55.4379 494.601 68.7942 502.114L280.849 624.528C294.205 632.224 325.492 607.668 325.492 592.458V583.479C325.492 568.269 338.299 544.08 325.126 536.383L246.817 492.585Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1905,
    d: "M236.937 488.187C223.581 480.491 59.829 418.551 59.829 433.761V430.829C59.829 446.039 55.4379 492.036 68.6113 499.732L280.3 622.145C293.656 629.842 323.845 606.386 323.845 590.992V583.296C323.845 568.086 335.372 544.079 322.198 536.566L236.937 488.187Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2381,
    d: "M227.057 483.789C213.884 476.092 58.9142 418.001 58.9142 433.394V429.913C58.9142 445.123 55.4379 489.47 68.6113 497.167L280.3 619.397C293.473 627.093 322.747 604.553 322.747 589.343V582.746C322.747 567.536 332.993 543.896 319.82 536.2L227.057 483.789Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2857,
    d: "M217.36 479.391C204.187 471.694 58.3653 417.635 58.3653 432.845V428.813C58.3653 444.023 55.6208 486.721 68.9771 494.418L280.3 616.465C293.473 624.161 321.466 602.721 321.466 587.511V582.013C321.466 566.803 330.432 543.53 317.258 535.833L217.36 479.391Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M207.48 474.993C194.307 467.296 57.4505 417.268 57.4505 432.478V427.897C57.4505 443.107 55.6208 484.156 68.9771 491.852L280.117 613.899C293.29 621.596 320.186 601.071 320.186 585.861V581.646C320.186 566.436 327.87 543.53 314.697 535.833L207.48 474.993Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.381,
    d: "M197.6 470.412C184.427 462.715 56.5357 416.718 56.5357 431.928V426.981C56.5357 442.191 55.6209 481.59 68.9772 489.287L279.934 611.15C293.107 618.847 318.905 599.422 318.905 584.212V581.097C318.905 565.887 325.309 543.346 311.952 535.65L197.6 470.412Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M187.72 466.014C174.547 458.317 55.8038 416.352 55.8038 431.562V426.064C55.8038 441.274 55.8038 479.025 68.9772 486.721L279.751 608.401C292.924 616.098 317.441 597.773 317.441 582.563V580.547C317.441 565.337 322.564 543.163 309.208 535.467L187.72 466.014Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4762,
    d: "M178.023 461.615C164.85 453.919 55.072 415.985 55.072 431.195V425.148C55.072 440.358 55.9868 476.459 69.1602 484.156L279.751 605.836C292.924 613.533 316.343 596.123 316.343 580.913V580.18C316.343 564.97 320.003 542.98 306.829 535.467L178.023 461.615Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5238,
    d: "M168.143 457.217C154.97 449.521 54.1572 415.619 54.1572 430.829V424.232C54.1572 439.442 55.9869 473.893 69.1602 481.59L279.568 603.087C292.741 610.784 314.88 594.474 314.88 579.264V579.631C314.88 564.421 317.258 542.797 304.085 535.283L168.143 457.217Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5714,
    d: "M158.263 452.819C145.09 445.123 53.2423 415.252 53.2423 430.279V423.132C53.2423 438.342 55.9868 471.328 69.1601 478.841L279.202 600.338C292.375 608.035 313.416 592.642 313.416 577.432V578.898C313.416 563.688 314.514 542.43 301.34 534.734L158.263 452.819Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.619,
    d: "M148.383 448.421C135.21 440.725 52.5105 414.886 52.5105 429.913V422.216C52.5105 437.426 55.9868 468.762 69.1601 476.276L279.019 597.59C292.192 605.286 312.135 590.992 312.135 575.782V578.531C312.135 563.321 311.952 542.43 298.779 534.734L148.383 448.421Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M138.686 443.84C125.513 436.143 51.7787 414.153 51.7787 429.363V421.116C51.7787 436.326 56.1698 466.014 69.3432 473.527L279.019 594.657C292.192 602.354 310.855 588.977 310.855 573.95V577.798C310.855 562.588 309.391 542.064 296.218 534.367L138.686 443.84Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M128.806 439.442C115.633 431.745 50.8639 413.786 50.8639 428.996V420.2C50.8639 435.41 56.1698 463.448 69.3432 471.145L278.836 592.275C292.009 599.972 309.574 587.694 309.574 572.484V577.432C309.574 562.222 306.829 541.88 293.656 534.367L128.806 439.442Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7619,
    d: "M118.926 435.044C105.753 427.347 50.132 413.42 50.132 428.63V419.284C50.132 434.494 56.3527 460.882 69.5261 468.579L278.836 589.526C292.009 597.223 308.476 585.861 308.476 570.835V577.065C308.476 561.855 304.451 541.88 291.277 534.367L118.926 435.044Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8095,
    d: "M109.046 430.646C95.8728 422.949 49.2172 413.053 49.2172 428.263V418.368C49.2172 433.578 56.3527 458.317 69.5261 466.014L278.653 586.778C291.826 594.474 307.012 584.212 307.012 569.002V576.332C307.012 561.122 301.523 541.514 288.533 534.001L109.046 430.646Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8571,
    d: "M99.1661 426.248C85.9928 418.734 48.3024 412.687 48.3024 427.897V417.451C48.3024 432.478 56.3528 455.751 69.3431 463.448L278.287 584.212C291.46 591.725 305.549 582.746 305.549 567.536V575.966C305.549 560.939 298.779 541.514 285.606 533.817L99.1661 426.248Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9048,
    d: "M89.469 421.849C76.2957 414.336 47.7534 412.32 47.7534 427.347V416.535C47.7534 431.562 56.5356 453.186 69.709 460.882L278.47 581.463C291.643 588.977 304.634 580.913 304.634 565.887V575.599C304.634 560.572 296.583 541.514 283.41 533.817L89.469 421.849Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9524,
    d: "M79.589 417.268C66.4157 409.755 46.8386 411.771 46.8386 426.797V415.436C46.8386 430.462 56.5357 450.437 69.709 458.134L278.104 578.714C291.277 586.228 302.987 579.264 302.987 564.054V574.866C302.987 559.839 293.656 541.147 280.483 533.451L79.589 417.268Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.709 412.87C56.5357 405.357 45.9238 411.404 45.9238 426.431V414.519C45.9238 429.546 56.5357 448.055 69.709 455.568L277.921 575.966C291.094 583.479 301.706 577.432 301.706 562.405V574.316C301.706 559.29 291.094 540.781 277.921 533.268L69.709 412.87Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.7942 386.115C65.6838 383 60.7438 382.816 55.0719 386.115C45.9238 391.429 38.4223 404.074 38.0564 414.703C38.0564 414.703 38.0564 419.65 38.0564 420.933C38.0564 422.949 37.8734 459.233 37.8734 459.416C37.8734 469.129 31.6527 480.857 23.4193 487.088C37.5075 495.151 222.666 600.705 246.634 614.632C246.634 614.632 250.477 618.297 252.306 618.664C252.489 618.664 263.101 623.978 269.322 626.91C269.322 629.842 269.322 631.675 269.322 631.675C269.322 638.455 272.249 642.67 276.823 643.586C277.189 643.586 277.555 643.769 277.921 643.769C278.104 643.769 278.47 643.769 278.653 643.769C278.836 643.769 279.019 643.769 279.202 643.769C281.214 643.586 283.593 642.853 285.971 641.387C288.533 639.921 290.911 637.722 293.107 635.34C295.852 632.774 297.864 629.842 299.145 626.177C301.523 621.412 302.804 616.465 302.804 611.883C302.804 611.883 302.987 610.051 302.987 608.035C302.987 607.119 302.987 612.433 302.987 569.002V568.819C302.987 567.169 302.987 566.07 302.987 566.07C303.353 555.441 310.854 542.797 320.003 537.482C323.662 535.283 327.138 534.734 330.066 535.467L68.7942 386.115Z",
    fill: "url(#paint34_linear_28_640)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_28_640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.786 646.774C277.786 643.476 278.517 639.811 279.981 636.329L11.5741 483.129L9.19558 481.663C7.91484 485.145 7.18298 488.626 7.18298 491.925C7.18298 497.606 10.2934 501.454 13.2208 503.103L282.36 657.036L281.994 656.853C279.249 655.204 277.786 651.722 277.786 646.774Z",
    fill: "url(#paint35_linear_28_640)",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.786 632.774C270.786 629.476 271.517 625.811 272.981 622.329L4.5741 469.129L2.19558 467.663C0.914836 471.145 0.182983 474.626 0.182983 477.925C0.182983 483.606 3.29336 487.454 6.22077 489.103L275.36 643.036L274.994 642.853C272.249 641.204 270.786 637.722 270.786 632.774Z",
    fill: "url(#paint36_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.823 568.819V564.237L170.339 503.58V508.162L276.823 568.819Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.834 509.261L276.823 550.127V545.546L205.834 504.68V509.261Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.764 529.236L276.823 559.656V555.075L223.764 524.655V529.236Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.537 549.76L116.548 508.895V513.476L187.537 554.342V549.76Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.607 529.786L116.548 499.366V503.947L169.607 534.367V529.786Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.19 526.487V521.906L116.182 463.265V467.846L219.19 526.487Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.26 506.696V502.114L149.115 472.061V476.642L201.26 506.696Z",
    fill: "#8D97D6"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0909091,
    d: "M113.803 257.654C107.399 253.989 102.276 264.068 102.276 271.215V362.842C102.276 370.172 107.399 378.968 113.803 382.633L221.202 442.74C227.606 446.405 234.925 443.107 234.925 435.777V337.186C234.925 329.856 227.423 321.427 221.202 317.761L113.803 257.654Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1818,
    d: "M113.62 258.204C107.216 254.539 102.093 263.885 102.093 271.032V362.109C102.093 369.439 107.216 378.235 113.62 381.9L220.837 441.824C227.24 445.489 234.376 442.191 234.376 435.044V337.553C234.376 330.223 227.24 321.793 220.837 318.128L113.62 258.204Z",
    fill: "#A0A5D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2727,
    d: "M113.62 258.571C107.216 254.906 102.093 263.518 102.093 270.665V361.376C102.093 368.706 107.216 377.502 113.62 381.167L220.654 440.908C227.057 444.573 234.01 441.274 234.01 434.127V337.919C234.01 330.589 227.057 322.16 220.654 318.495L113.62 258.571Z",
    fill: "#989CD3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3636,
    d: "M113.437 259.12C107.216 255.455 102.093 263.335 102.093 270.665V360.826C102.093 368.156 107.216 376.952 113.437 380.617L220.288 440.358C226.508 444.023 233.278 440.908 233.278 433.578V338.469C233.278 331.139 226.508 322.709 220.288 319.044L113.437 259.12Z",
    fill: "#9094CD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4545,
    d: "M113.254 259.67C107.033 256.005 101.91 263.152 101.91 270.482V360.093C101.91 367.423 107.033 376.219 113.254 379.884L219.922 439.442C226.142 443.107 232.729 439.992 232.729 432.661V338.836C232.729 331.505 226.325 323.076 219.922 319.411L113.254 259.67Z",
    fill: "#898BC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5455,
    d: "M113.071 260.037C106.85 256.372 101.727 262.785 101.727 270.116V359.36C101.727 366.507 106.85 375.486 113.071 378.968L219.556 438.525C225.776 442.191 232.18 439.075 232.18 431.745V339.019C232.18 331.872 225.959 323.076 219.556 319.594L113.071 260.037Z",
    fill: "#8183C1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6364,
    d: "M113.071 260.586C106.85 256.921 101.727 262.602 101.727 269.932V358.627C101.727 365.774 106.85 374.57 113.071 378.235L219.373 437.609C225.594 441.274 231.631 438.159 231.631 431.012V339.569C231.631 332.422 225.594 323.626 219.373 320.144L113.071 260.586Z",
    fill: "#7A7ABB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7273,
    d: "M112.888 261.136C106.667 257.471 101.544 262.602 101.544 269.749V357.894C101.544 365.041 106.667 373.837 112.888 377.502L219.007 436.693C225.228 440.358 231.082 437.243 231.082 430.096V339.752C231.082 332.605 225.228 323.809 219.007 320.144L112.888 261.136Z",
    fill: "#7272B5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8182,
    d: "M112.705 261.686C106.485 258.021 101.362 262.419 101.362 269.566V357.344C101.362 364.491 106.485 373.287 112.705 376.952L218.641 436.143C224.862 439.808 230.534 436.876 230.534 429.546V340.485C230.534 333.338 225.045 324.542 218.641 320.877L112.705 261.686Z",
    fill: "#6A69AF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9091,
    d: "M112.522 262.052C106.302 258.387 101.179 262.052 101.179 269.199V356.428C101.179 363.575 106.302 372.371 112.522 376.036L218.275 435.044C224.496 438.709 229.802 435.777 229.802 428.447V340.485C229.802 333.338 224.496 324.542 218.275 320.877L112.522 262.052Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.339 262.602C106.119 258.937 100.996 261.869 100.996 269.016V355.695C100.996 362.842 106.119 371.638 112.339 375.303L217.909 434.311C224.13 437.976 229.253 435.044 229.253 427.897V341.218C229.253 334.071 224.13 325.275 217.909 321.61L112.339 262.602Z",
    fill: "#5B58A3"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M219.922 434.677L88.0053 360.826C81.9675 357.344 77.2104 348.182 77.2104 340.118V257.288C77.2104 249.225 81.9675 245.56 88.0053 249.041L219.922 322.893C225.96 326.374 230.717 335.537 230.717 343.6V426.431C230.717 434.494 225.777 438.159 219.922 434.677Z",
    fill: "url(#paint37_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.922 322.893L88.0052 249.041C83.4312 246.476 79.5889 247.942 77.9423 252.34C79.7719 248.675 83.4312 247.575 87.6393 249.958L219.556 323.809C225.594 327.291 230.351 336.453 230.351 344.516V427.347C230.351 429.18 229.985 430.829 229.619 432.295C230.351 430.829 230.899 428.813 230.899 426.431V343.6C230.717 335.537 225.777 326.191 219.922 322.893Z",
    fill: "url(#paint38_radial_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.982 374.204L191.928 394.728V389.047L156.982 368.523V374.204ZM171.985 370.355L216.08 395.278V389.597L171.985 364.674V370.355ZM152.957 366.324L129.538 352.763V358.444L152.957 372.005V366.324ZM167.96 362.475L129.538 339.752V345.433L167.96 368.156V362.475Z",
    fill: "#CED3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.39 332.605L94.7749 317.028C94.7749 325.275 94.7749 341.218 94.7749 346.349L120.39 361.009V332.605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.39 358.627L95.8727 344.516C95.8727 339.935 95.8727 324.725 95.8727 317.761L94.7749 317.028C94.7749 325.275 94.7749 341.218 94.7749 346.349L120.39 361.009V358.627Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.982 326.741L182.231 341.768V336.087L156.982 321.06V326.741ZM152.957 318.861L129.538 305.3V310.981L152.957 324.542V318.861ZM174.364 318.678L129.538 292.106V297.787L174.364 324.359V318.678Z",
    fill: "#CED3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.39 285.142L94.7749 269.566C94.7749 277.812 94.7749 293.755 94.7749 298.886L120.39 313.547V285.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.39 310.981L95.8727 296.871C95.8727 292.289 95.8727 277.079 95.8727 270.116L94.7749 269.383C94.7749 277.629 94.7749 293.572 94.7749 298.703L120.39 313.363V310.981Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7149 287.525L105.753 300.902L117.096 288.991C117.462 288.624 117.279 287.525 116.548 286.975L113.071 283.86C112.522 283.493 112.156 283.31 111.973 283.676L105.753 294.122L103.008 287.708C102.825 287.158 102.276 286.608 101.91 286.608L100.081 286.242C99.7149 286.059 99.349 286.792 99.7149 287.525Z",
    fill: "#273B98"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0909091,
    d: "M399.226 223.019C389.163 217.155 381.112 221.92 381.112 233.465V250.507C381.112 262.052 389.163 276.163 399.226 281.844L528.581 356.428C538.644 362.292 550.353 356.978 550.353 345.433V328.39C550.353 316.845 538.461 303.468 528.581 297.604L399.226 223.019Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1818,
    d: "M398.677 223.752C388.614 217.888 380.563 222.653 380.563 234.015V249.774C380.563 261.319 388.614 275.247 398.677 281.111L527.483 355.328C537.546 361.193 548.89 355.878 548.89 344.516V328.757C548.89 317.212 537.546 303.834 527.483 297.97L398.677 223.752Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2727,
    d: "M398.128 224.669C388.248 218.988 380.198 223.569 380.198 234.931V249.408C380.198 260.77 388.248 274.697 398.128 280.561L526.385 354.412C536.265 360.093 547.243 355.145 547.243 343.6V329.123C547.243 317.761 536.265 304.201 526.385 298.52L398.128 224.669Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3636,
    d: "M397.579 225.402C387.699 219.721 379.649 224.302 379.649 235.664V248.858C379.649 260.22 387.699 274.147 397.579 279.828L525.104 353.313C534.984 358.993 545.596 354.046 545.596 342.684V329.49C545.596 318.128 534.984 304.75 525.104 298.886L397.579 225.402Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4545,
    d: "M397.03 226.135C387.15 220.454 379.283 225.035 379.283 236.397V248.308C379.283 259.67 387.333 273.414 397.03 279.095L524.007 352.213C533.887 357.894 543.95 352.946 543.95 341.768V329.856C543.95 318.494 533.704 305.117 524.007 299.436L397.03 226.135Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5455,
    d: "M396.481 227.051C386.601 221.37 378.734 225.951 378.734 237.13V247.759C378.734 258.937 386.601 272.681 396.481 278.362L522.909 351.297C532.789 356.978 542.486 352.213 542.486 340.851V330.223C542.486 319.044 532.789 305.484 522.909 299.803L396.481 227.051Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6364,
    d: "M395.932 227.784C386.235 222.103 378.368 226.685 378.368 237.863V247.209C378.368 258.387 386.235 272.131 395.932 277.629L521.628 350.197C531.325 355.878 540.656 351.114 540.656 339.935V330.589C540.656 319.411 531.325 306.033 521.628 300.352L395.932 227.784Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7273,
    d: "M395.384 228.7C385.687 223.019 377.819 227.601 377.819 238.779V246.842C377.819 258.021 385.687 271.582 395.384 277.079L520.53 349.281C530.227 354.962 539.193 350.197 539.193 339.019V330.956C539.193 319.777 530.227 306.4 520.53 300.719L395.384 228.7Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8182,
    d: "M394.835 229.433C385.138 223.936 377.453 228.334 377.453 239.329V246.109C377.453 257.105 385.321 270.665 394.835 276.346L519.433 348.182C529.13 353.679 537.546 349.098 537.546 338.103V331.322C537.546 320.327 528.947 306.766 519.433 301.269L394.835 229.433Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9091,
    d: "M394.286 230.35C384.772 224.852 376.904 229.25 376.904 240.245V245.743C376.904 256.738 384.772 270.299 394.286 275.796L518.335 347.265C527.849 352.763 536.082 348.365 536.082 337.37V331.872C536.082 320.877 527.849 307.499 518.335 302.002L394.286 230.35Z",
    fill: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.737 231.083C384.223 225.585 376.538 229.983 376.538 240.978V245.193C376.538 256.188 384.223 269.566 393.737 275.063L517.054 346.166C526.568 351.663 534.253 347.265 534.253 336.27V332.055C534.253 321.06 526.568 307.683 517.054 302.185L393.737 231.083Z",
    fill: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M528.764 356.611L389.346 276.529C381.112 271.765 374.343 258.754 374.343 247.759V239.879C374.343 228.884 381.112 223.752 389.346 228.517L528.764 308.599C536.997 313.363 543.767 326.374 543.767 337.37V345.249C543.767 356.245 536.997 361.376 528.764 356.611Z",
    fill: "url(#paint39_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.764 308.599L389.346 228.517C381.112 223.752 374.343 228.884 374.343 239.879V241.528C374.343 230.533 381.112 225.402 389.346 230.166L528.764 310.248C536.997 315.013 543.767 328.024 543.767 339.019V337.37C543.767 326.374 536.997 313.363 528.764 308.599Z",
    fill: "url(#paint40_radial_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.863 268.1C413.863 272.315 410.935 273.964 407.276 271.948C403.617 269.749 400.689 264.618 400.689 260.403C400.689 256.188 403.617 254.539 407.276 256.555C410.752 258.754 413.863 263.885 413.863 268.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.721 280.011C434.721 284.226 431.793 285.875 428.134 283.86C424.475 281.661 421.547 276.529 421.547 272.315C421.547 268.1 424.475 266.451 428.134 268.466C431.61 270.665 434.721 275.796 434.721 280.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.578 292.106C455.578 296.321 452.651 297.97 448.992 295.954C445.332 293.939 442.405 288.624 442.405 284.409C442.405 280.195 445.332 278.545 448.992 280.561C452.468 282.76 455.578 287.891 455.578 292.106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.436 304.201C476.436 308.416 473.509 310.065 469.849 308.049C466.19 305.85 463.263 300.719 463.263 296.504C463.263 292.289 466.19 290.64 469.849 292.656C473.326 294.855 476.436 299.986 476.436 304.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.294 316.295C497.294 320.51 494.367 322.16 490.707 320.144C487.048 317.945 484.121 312.814 484.121 308.599C484.121 304.384 487.048 302.735 490.707 304.75C494.184 306.95 497.294 312.081 497.294 316.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.152 328.39C518.152 332.605 515.224 334.254 511.565 332.238C507.906 330.039 504.979 324.908 504.979 320.694C504.979 316.479 507.906 314.829 511.565 316.845C515.042 319.044 518.152 324.175 518.152 328.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.026 179.405L250.477 179.039V161.446C250.477 150.268 242.609 136.524 232.729 130.843L220.471 123.696C210.774 118.015 202.723 122.597 202.723 133.775V151.367L202.174 151.001C197.6 148.435 193.941 150.451 193.941 155.765V197.364C193.941 202.678 197.6 208.909 202.174 211.658L251.026 239.879C255.6 242.444 259.259 240.429 259.259 235.114V193.516C259.259 188.568 255.6 182.154 251.026 179.405ZM229.619 200.113V213.674L223.581 210.192V196.631C221.203 193.882 219.373 190.034 219.373 186.735C219.373 182.154 222.666 180.321 226.508 182.704C230.534 185.086 233.644 190.584 233.644 195.165C233.827 198.463 232.18 200.296 229.619 200.113ZM240.231 173.174L213.152 157.598V143.487C213.152 137.074 217.726 134.508 223.215 137.807L230.168 141.838C235.657 145.137 240.231 152.833 240.231 159.247V173.174Z",
    fill: "url(#paint41_linear_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.165 137.623C213.152 138.54 211.871 140.922 211.871 144.22V158.331L238.95 174.091V172.441L213.152 157.598V143.487C213.152 140.922 213.884 138.906 215.165 137.623Z",
    fill: "url(#paint42_radial_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.338 214.59V212.941L223.581 210.192V196.631C221.203 193.882 219.373 190.034 219.373 186.735C219.373 185.086 219.739 183.62 220.654 182.887C219.19 183.437 218.092 185.086 218.092 187.652C218.092 190.95 219.739 194.798 222.3 197.547V211.108L228.338 214.59Z",
    fill: "url(#paint43_radial_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.026 179.405L250.477 179.039V161.446C250.477 150.268 242.609 136.524 232.729 130.843L220.471 123.696C214.982 120.581 210.042 120.581 206.749 123.146C209.859 121.314 214.25 121.68 219.19 124.429L231.449 131.576C241.146 137.257 249.196 151.001 249.196 162.179V179.772L249.745 180.138C254.319 182.704 257.978 189.118 257.978 194.432V236.03C257.978 238.046 257.429 239.696 256.332 240.612C258.161 239.879 259.259 238.046 259.259 235.114V193.516C259.259 188.568 255.6 182.154 251.026 179.405Z",
    fill: "url(#paint44_radial_28_640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.894 152.1L201.443 152.467V150.818C199.064 149.718 196.868 149.901 195.405 151.184C197.051 150.634 198.881 151.001 200.894 152.1Z",
    fill: "url(#paint45_radial_28_640)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_28_640",
    x: -17.817,
    y: 456.663,
    width: 325.177,
    height: 225.374,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_28_640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_640",
    x1: 482.917,
    y1: 136.864,
    x2: 565.726,
    y2: 366.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2899,
    stopColor: "#07CDBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3434,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4359,
    stopColor: "#09BECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5859,
    stopColor: "#21A7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7738,
    stopColor: "#4881F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8173,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_640",
    x1: 566.704,
    y1: 155.107,
    x2: 467.879,
    y2: 287.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1037,
    stopColor: "#90F36C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3332,
    stopColor: "#35EA9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    stopColor: "#2BE9A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6616,
    stopColor: "#65C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8435,
    stopColor: "#5B9FFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28_640",
    x1: 28.9046,
    y1: 97.2061,
    x2: 73.9913,
    y2: 267.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    stopColor: "#BB6DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#976DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5556,
    stopColor: "#836DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#796FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9246,
    stopColor: "#5D75F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_28_640",
    x1: 12.986,
    y1: 221.06,
    x2: 82.8146,
    y2: 146.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030303,
    stopColor: "#BB6DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#976DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5556,
    stopColor: "#836DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#796FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9246,
    stopColor: "#5D75F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_28_640",
    x1: 135.184,
    y1: 394.336,
    x2: 686.461,
    y2: 394.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1771,
    stopColor: "#BAC1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3303,
    stopColor: "#C5CBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#D1D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#DBE0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5251,
    stopColor: "#D1D6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_28_640",
    x1: 353.451,
    y1: 235.258,
    x2: 284.334,
    y2: 413.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1449,
    stopColor: "#B6BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3485,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8551,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_28_640",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(308.439 369.051) scale(152.808 153.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_28_640",
    x1: -58.5427,
    y1: 146.154,
    x2: 615.335,
    y2: 293.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1449,
    stopColor: "#B6BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3485,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8551,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_28_640",
    x1: 174.536,
    y1: 22.9371,
    x2: 465.262,
    y2: 459.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_28_640",
    x1: 253.688,
    y1: -37.6599,
    x2: 490.883,
    y2: 436.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3BAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#BAC0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3BAE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_28_640",
    x1: 253.585,
    y1: -37.5726,
    x2: 490.765,
    y2: 436.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4BBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#B9BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#BCC2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#B2B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#B2B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#B3B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4BBE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_28_640",
    x1: 253.481,
    y1: -37.4854,
    x2: 490.647,
    y2: 436.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#BDC3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#B4BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#B4BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#B7BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5BCE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_28_640",
    x1: 253.378,
    y1: -37.3982,
    x2: 490.529,
    y2: 436.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#BCC1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#BFC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#BAC0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7BDE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_28_640",
    x1: 253.274,
    y1: -37.311,
    x2: 490.411,
    y2: 437.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#BDC3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C1C6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#BEC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8BFE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_28_640",
    x1: 253.171,
    y1: -37.2237,
    x2: 490.293,
    y2: 437.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#BFC4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C2C8ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#C2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9C0EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_28_640",
    x1: 253.068,
    y1: -37.1367,
    x2: 490.176,
    y2: 437.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAC1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C0C6ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C4C9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#BEC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#C6CBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#B2B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#BAC1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_28_640",
    x1: 252.964,
    y1: -37.0495,
    x2: 490.058,
    y2: 437.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C2C7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C6CBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#C1C7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#C1C7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#CACEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#B6BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_28_640",
    x1: 252.861,
    y1: -36.9622,
    x2: 489.94,
    y2: 437.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C4C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#C3C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#C4C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#CDD2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6644,
    stopColor: "#B9C0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9836,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_28_640",
    x1: 252.757,
    y1: -36.8752,
    x2: 489.822,
    y2: 437.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C5CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#C9CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#C6CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#C6CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5289,
    stopColor: "#D0D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#D1D5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#BDC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9797,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEC4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_28_640",
    x1: 252.654,
    y1: -36.7881,
    x2: 489.704,
    y2: 437.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C7CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#C8CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#C9CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5228,
    stopColor: "#D3D7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#D5D9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6403,
    stopColor: "#C1C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9763,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_28_640",
    x1: 252.55,
    y1: -36.7009,
    x2: 489.586,
    y2: 437.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#CCD1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#CBD1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#D5D9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#D9DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6316,
    stopColor: "#C5CAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9704,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C7ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_28_640",
    x1: 252.447,
    y1: -36.6138,
    x2: 489.469,
    y2: 437.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#CACFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#CED3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#CDD3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#D8DCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#DDE0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6245,
    stopColor: "#C9CEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9679,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_28_640",
    x1: 252.343,
    y1: -36.5268,
    x2: 489.351,
    y2: 437.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3C9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D0D4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#D0D5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#D0D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    stopColor: "#DADEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#E1E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6182,
    stopColor: "#CDD1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9656,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C9EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_28_640",
    x1: 252.24,
    y1: -36.4398,
    x2: 489.233,
    y2: 437.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#CDD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D1D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#D2D7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    stopColor: "#DDE1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#E4E7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6142,
    stopColor: "#D0D5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4CAEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_28_640",
    x1: 252.136,
    y1: -36.3529,
    x2: 489.115,
    y2: 437.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#CFD3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#D5DAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#D6DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4993,
    stopColor: "#E0E3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#E8EAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    stopColor: "#D4D8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9597,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_28_640",
    x1: 252.033,
    y1: -36.2659,
    x2: 488.997,
    y2: 437.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D0D5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D5D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#D7DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#D8DDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    stopColor: "#E2E6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6051,
    stopColor: "#D8DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9581,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7CCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_28_640",
    x1: 251.929,
    y1: -36.179,
    x2: 488.879,
    y2: 437.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D2D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D6DBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#DADEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#DBDFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4921,
    stopColor: "#E5E8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#F0F1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6013,
    stopColor: "#DCDFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9566,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8CDF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_28_640",
    x1: 251.826,
    y1: -36.0923,
    x2: 488.761,
    y2: 437.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#D8DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#DCE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4882,
    stopColor: "#E7EAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#F4F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#E0E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9551,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9CFF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_28_640",
    x1: 251.722,
    y1: -36.0056,
    x2: 488.644,
    y2: 437.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D5D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#DADEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#DFE3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#E0E4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4882,
    stopColor: "#EAEDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#F7F8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5957,
    stopColor: "#E3E6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7185,
    stopColor: "#B1B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9526,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBD0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_28_640",
    x1: 251.618,
    y1: -35.919,
    x2: 488.526,
    y2: 437.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#D6DBF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2828,
    stopColor: "#DBDFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4091,
    stopColor: "#E1E6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#E2E7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    stopColor: "#ECEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#FBFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#E7EAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7101,
    stopColor: "#B5BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9514,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_28_640",
    x1: 251.514,
    y1: -35.8326,
    x2: 488.408,
    y2: 438.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4834,
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5905,
    stopColor: "#EBEDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7024,
    stopColor: "#B9BFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9503,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_28_640",
    x1: 225.299,
    y1: 430.948,
    x2: 375.663,
    y2: 170.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0127482,
    stopColor: "#D3D8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0562747,
    stopColor: "#E1E5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0959596,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#EAEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_28_640",
    x1: 422.181,
    y1: -23.7694,
    x2: -96.516,
    y2: 614.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#3A54D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0493414,
    stopColor: "#796FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1471,
    stopColor: "#356BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#2800C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6617,
    stopColor: "#5B76F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7684,
    stopColor: "#7374F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#9A70F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_28_640",
    x1: 189.489,
    y1: 492.051,
    x2: 299.128,
    y2: 302.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0127482,
    stopColor: "#D3D8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0562747,
    stopColor: "#E1E5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0959596,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4484,
    stopColor: "#E8ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7192,
    stopColor: "#F2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9242,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_28_640",
    x1: 145.985,
    y1: 556.718,
    x2: 200.961,
    y2: 461.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0127482,
    stopColor: "#D3D8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0562747,
    stopColor: "#E1E5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0959596,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4484,
    stopColor: "#E8ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7192,
    stopColor: "#F2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9242,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_28_640",
    x1: 115.426,
    y1: 621.134,
    x2: 150.161,
    y2: 562.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0977404,
    stopColor: "#AFB6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1667,
    stopColor: "#98A0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5212,
    stopColor: "#8195F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7937,
    stopColor: "#98A0CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_28_640",
    x1: 108.426,
    y1: 607.134,
    x2: 143.161,
    y2: 548.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0221417,
    stopColor: "#D3D8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0977404,
    stopColor: "#E1E5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1667,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5212,
    stopColor: "#E8ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7937,
    stopColor: "#F2F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_28_640",
    x1: 372.458,
    y1: 104.236,
    x2: 103.066,
    y2: 396.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#3A54D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0493414,
    stopColor: "#6F9AED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1471,
    stopColor: "#357FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#0008C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596,
    stopColor: "#3256D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6617,
    stopColor: "#5B76F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7684,
    stopColor: "#3F20BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#2D50CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_28_640",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.305 340.005) scale(84.6551 84.7894)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_28_640",
    x1: 491.167,
    y1: 254.574,
    x2: 402.994,
    y2: 358.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0454545,
    stopColor: "#559AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1421,
    stopColor: "#687CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284375,
    stopColor: "#404DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414583,
    stopColor: "#2967DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6374,
    stopColor: "#069BCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6818,
    stopColor: "#005CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8394,
    stopColor: "#4621D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9617,
    stopColor: "#4881F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9899,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_28_640",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(450.669 273.793) scale(159.312 159.565)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1614,
    stopColor: "#6C1E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3626,
    stopColor: "#5C1946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5849,
    stopColor: "#431233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8208,
    stopColor: "#200918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_28_640",
    x1: 296.926,
    y1: 117.355,
    x2: 131.678,
    y2: 281.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00505051,
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0493414,
    stopColor: "#90ED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1471,
    stopColor: "#35D5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6617,
    stopColor: "#5B76F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7684,
    stopColor: "#7374F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#9A70F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_28_640",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(228.804 154.425) scale(16.0221 16.0475)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_28_640",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(214.252 199.381) scale(14.4861 14.5091)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_28_640",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(261.82 145.785) scale(46.0105 46.0835)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_28_640",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.647 156.525) scale(7.65554 7.66766)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 552,
    height: 650,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthLayer);
export default __webpack_public_path__ + "static/media/auth-layer.d85dea3495baa255680009fc7603f068.svg";
export { ForwardRef as ReactComponent };